import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const EN = {
  // Auth
  login: "Login", email: "Email Address", password: "Password",
  loginButton: "Login", noAccount: "Don't have an account?", registerHere: "Register here",
  loggingIn: "Logging in...", signingIn: "Signing in…", loginTagline: "Secure · Elegant · Powerful",
  forgotPasswordLink: "Forgot password?",
  register: "Register", fullName: "Full Name", createAccount: "Create Account",
  registerButton: "Register", registering: "Registering...", alreadyAccount: "Already have an account?",
  loginHere: "Login here",
  passwordHint: "Password must have: 8+ characters, uppercase, lowercase, number & special character (@$!%*?&)",
  reg_step1: "Step 1 of 2 — Your Details", reg_step2: "Step 2 of 2 — Preferred Language",
  reg_pickOnce: "Pick once — change anytime from Settings inside the app.",
  reg_next: "Next →", reg_creating: "Creating account…", reg_back: "← Back",
  chooseLanguage: "Choose your preferred language",
  verifyEmail: "Verify Email", enterOtp: "Enter 6-digit OTP", verifyButton: "Verify OTP",
  verifying: "Verifying...", resendOtp: "Resend OTP", sending: "Sending...",
  otpExpiry: "OTP expires in 10 minutes", otpSentTo: "OTP sent to",
  selectLanguage: "Select Language", continue: "Continue",
  forgotPassword: "Forgot Password?", resetPassword: "Reset Password", sendOtp: "Send OTP",
  newPassword: "New Password", confirmPassword: "Confirm New Password",
  fp_tagline: "Reset Password",
  fp_step1: "Step 1 of 2 — Enter your email",
  fp_emailPlaceholder: "Your registered email",
  fp_sendingOtp: "Sending OTP…", fp_sendResetOtp: "Send Reset OTP",
  fp_step2: "Step 2 of 2 — Enter OTP & new password",
  fp_newPasswordPlaceholder: "New Password",
  fp_confirmPasswordPlaceholder: "Confirm New Password",
  fp_resetting: "Resetting…", fp_resetPassword: "Reset Password",
  fp_rememberPassword: "Remember your password?", fp_loginHere: "Login here",
  english: "English", hindi: "Hindi", telugu: "Telugu", tamil: "Tamil", malayalam: "Malayalam",
  // Dashboard
  dashboard: "Dashboard", myFolders: "My Folders", sharedWithMe: "Shared with Me",
  newFolder: "+ New Folder", searchFolders: "Search folders...", noFoldersYet: "No folders yet",
  createFirstFolder: "Create your first folder to get started.",
  createFirstFolderBtn: "+ Create First Folder",
  totalFolders: "Total Folders", totalFiles: "Total Files", daysActive: "Days Active", badgesEarned: "Badges Earned",
  // Folder modal
  folderName: "Folder Name *", description: "Description", tags: "Tags (comma separated)",
  status: "Status", dueDate: "Due Date", changeNote: "Change Note (optional)",
  addFiles: "Add Files (optional)", dropFiles: "Click or drag & drop files",
  anyFileType: "Any file type · Max 25MB each · Multiple OK",
  saveChanges: "Save Changes", cancel: "Cancel",
  createFolder: "📁 Create Folder", createFolderBtn: "📁 Create Folder",
  editFolder: "✏️ Edit Folder", deleteFolder: "🗑️ Delete",
  share: "🔗 Share", sharingOn: "🔗 Sharing On",
  sharingDisabled: "Sharing disabled",
  sharingEnabled: "Sharing enabled — anyone with the link can view",
  saving: "Saving…",
  // Files
  files: "Files", noFilesYet: "No files yet — upload some below",
  clickToView: "Click to view · ↓ to download",
  dropFilesHere: "Drop files here or click to upload",
  view: "View", edit: "Edit", download: "↓", delete: "✕", aiAnalyse: "🤖 AI",
  uploadMoreFiles: "Upload more files",
  // Drawer tabs
  details: "Details", comments: "Comments", activity: "Activity", history: "History",
  // Status
  active: "Active", inProgress: "In Progress", completed: "Completed", onHold: "On Hold", archived: "Archived",
  allStatuses: "All statuses",
  // Drawer content
  publicShareLink: "Public Share Link", tags2: "Tags",
  noCommentsYet: "No comments yet — type @ to mention someone!",
  addComment: "Add a comment… type @ to mention",
  post: "Post", noActivityYet: "No activity yet. Edits, comments and shares appear here.",
  noVersionHistory: "No version history yet.",
  historyAutoSaves: "History saves automatically when you edit.",
  restore: "↩ Restore", savedVersions: "saved versions", current: "Current",
  restoreVersion: "Restore to this version?",
  // Recycle Bin
  recycleBin: "Recycle Bin", restoreOrDelete: "Restore or permanently delete projects",
  binIsEmpty: "Recycle bin is empty", deletedAppearHere: "Deleted projects will appear here.",
  restoreProject: "↩ Restore", deleteForever: "✕ Delete Forever",
  // Collaboration
  collaboration: "Collaboration", inviteTeammates: "Invite teammates · manage requests",
  sendInvite: "✉️ Send Invite", received: "📬 Received", sent: "📤 Sent",
  findUsers: "🔍 Find Users", typeToSearch: "Type to search users",
  emailAddress: "Email address *", project: "Project", role: "Role",
  viewer: "Viewer", editor: "Editor", admin: "Admin",
  sendInviteBtn: "Send Invite", sending2: "Sending…",
  noInvitationsReceived: "No invitations received", noInvitesSent: "No invites sent yet",
  accept: "Accept ✅", decline: "Decline ❌", cancel2: "Cancel",
  inviteAccepted: "Accepted", inviteDeclined: "Declined", invitePending: "Pending",
  // Analytics
  analytics: "Analytics", personalDashboard: "Your personal VaultSphere activity dashboard",
  activityHeatmap: "Activity Heatmap", lastYear: "Folder creations + file uploads over the last year",
  filesUploaded: "Files Uploaded", foldersCreated: "Folders Created",
  last6Months: "Last 6 months", folderStatus: "Folder Status", breakdownByStatus: "Breakdown by status",
  mostActiveFolders: "Most Active Folders", byNumberOfFiles: "By number of files",
  noFoldersYet2: "No folders yet", badgesEarned2: "Badges Earned 🏆",
  badgesUnlocked: "of 6 badges unlocked", refresh: "↻ Refresh",
  // Teams
  teams: "Teams", createTeams: "Create teams and invite members to collaborate",
  newTeam: "+ New Team", createNewTeam: "Create a New Team",
  teamName: "Team name e.g. Design Squad, Backend Team…",
  createTeamBtn: "Create Team", noTeamsYet: "No teams yet",
  createTeamSub: "Create a team to collaborate with your group on shared projects.",
  createFirstTeam: "+ Create First Team",
  members: "Members", inviteSomeone: "Invite someone",
  enterEmail: "Enter email address…", addBtn: "+ Add", adding: "Adding…",
  mustHaveAccount: "The person must already have a VaultSphere account",
  deleteTeam: "🗑️ Delete Team", remove: "Remove", owner: "👑 Owner", you: "you",
  // Certificates
  certificates: "Certificates", certificatesSubtitle: "Store and showcase all your certificates in one place",
  addCertificate: "+ Add Certificate", addAnotherCertificate: "Add Another Certificate",
  addFirstCertificate: "+ Add First Certificate",
  noCertificatesYet: "No certificates yet",
  noCertSub: "Add your certificates from Coursera, NPTEL, Google, Udemy and more. Keep them all in one place!",
  certName: "Certificate Name *", certNamePlaceholder: "e.g. AWS Cloud Practitioner, Python Bootcamp…",
  certIssuer: "Issued By", certIssuerPlaceholder: "e.g. Coursera, NPTEL, Google, Udemy…",
  certDate: "Issue Date", certTags: "Tags (comma separated)",
  certFile: "Upload Certificate File (PDF/Image)",
  certAdding: "Adding…", certAddBtn: "🏆 Add Certificate",
  totalCertificates: "Total Certificates", filesStored: "Files Stored", skillsTagged: "Skills Tagged",
  issuedBy: "Issued by:",
  // Survey banner
  survey: "Survey", shareFeedback: "Share your feedback",
  surveyBannerTitle: "Help us improve VaultSphere!",
  surveyBannerSub: "Takes only 2 minutes · Your feedback trains our AI model 🤖",
  takeSurvey: "Take Survey →", surveyAlreadyDone: "✅ You've already completed the survey — thank you!",
  startSurvey: "Start Survey →",
  helpUsImprove: "Help us improve VaultSphere",
  surveyDesc: "Take 2 minutes to share your feedback. Your responses help us build better features for you.",
  // Settings
  settings: "Settings", language: "Language", changeLanguage: "Change Language",
  currentLanguage: "Current language", signOut: "Sign Out",
  signOutDesc: "You'll be signed out and returned to the login page.", signOutBtn: "Sign Out",
  managePreferences: "Manage your preferences",
  changeLangDesc: "Change Language — applies everywhere instantly",
  accountSettings: "Account", accountDesc: "Update your name or password from your profile page.",
  openProfile: "Open Profile →", tutorialSettings: "Tutorial",
  tutorialDesc: "Replay the onboarding tutorial to learn VaultSphere features.",
  viewTutorial: "View Tutorial →",
  profile: "Profile",
  // Notifications
  notifications: "Notifications", allCaughtUp: "All caught up! No notifications.",
  markAllRead: "Mark all read", clearAll: "Clear all",
  // Search
  searchPlaceholder: "Search projects, tags, tech stack…",
  recentProjects: "Recent Projects", noTechStack: "No tech stack", noTags: "No tags",
  results: "results", navigate: "Navigate", open: "Open", close: "Close",
  searchNoResults: "No results for",
  // Pinned
  pinFolder: "📌 Pin", unpinFolder: "Unpin", pinnedFolders: "Pinned Folders",
  noPinnedFolders: "No pinned folders yet", pinHint: "Pin up to 3 folders for quick access",
  // Editor
  editorSaving: "Saving…", editorSave: "💾 Save",
  loadingFile: "Loading file content…", tabHint: "Tab = 2 spaces · Ctrl+S saves",
  fileAppearEmpty: "File appears empty — the content could not be loaded",
  tryReupload: "Try re-uploading the file",
  // AI
  analysingFile: "Analysing your file with AI…", aiMayTake: "This may take a few seconds",
  aiSummary: "📋 Summary", aiKeyPoints: "🔑 Key Points", aiComplexity: "⚡ Complexity",
  aiSuggestions: "💡 Suggestions", aiTags: "🏷️ Suggested Tags",
  // Misc
  logout: "Logout", logoutConfirm: "Are you sure you want to logout?",
  deleteConfirm: "Move to Recycle Bin?", deleteFileConfirm: "Delete this file?",
  deleteTeamConfirm: "Delete team? This cannot be undone.",
  permanentDeleteConfirm: "Permanently delete? Cannot be undone.",
  page: "Page", of: "of", prev: "← Prev", nextPage: "Next →",
  loading: "Loading…", error: "Error", success: "Success",
  overdue: "Overdue by", dueToday: "Due today!", dueIn: "Due in",
  // Tutorial steps
  tut_step1_title: "Create Your First Folder",
  tut_step1_desc: "VaultSphere organises your work into folders. Each folder holds multiple files — think of it like a project folder on your computer.",
  tut_step1_tip: "💡 Press N anywhere on the dashboard to instantly open the New Folder dialog",
  tut_step2_title: "Upload Files Inside Folders",
  tut_step2_desc: "Open any folder and drop files into it. Upload PDFs, code files, images, Word docs — any file type up to 25MB each.",
  tut_step2_tip: "💡 Upload multiple files at once — just select them all in the file picker",
  tut_step3_title: "AI File Analysis",
  tut_step3_desc: "Click the 🤖 AI button on any file and get an instant AI analysis — summary, key points, complexity rating and suggested tags. Powered by Groq AI.",
  tut_step3_tip: "💡 Works on code files, PDFs, text files and Word documents",
  tut_step4_title: "Collaborate with Teammates",
  tut_step4_desc: "Go to the Collaborate tab to invite teammates to your folders. They can view or edit files based on the role you assign them.",
  tut_step4_tip: "💡 Accepted invites appear under the Shared with Me tab on your dashboard",
  tut_step5_title: "Store Your Certificates",
  tut_step5_desc: "Got a certificate from Coursera, NPTEL or Google? Store it in the Certificates tab! Upload the PDF and keep all your achievements in one place.",
  tut_step5_tip: "💡 Certificates are auto-tagged and searchable by skill or provider",
  tut_step6_title: "Track Your Analytics",
  tut_step6_desc: "The Analytics tab shows your GitHub-style activity heatmap, files uploaded per month, folder status breakdown and badges you've earned.",
  tut_step6_tip: "💡 Earn badges as you use VaultSphere — upload files, collaborate, and more",
  tut_skip: "Skip →", tut_next: "Next →", tut_back: "← Back", tut_letsgo: "Let's go! 🚀",
  tut_nudge_title: "One last thing!",
  tut_nudge_desc1: "Could you fill out a quick 2-minute survey?",
  tut_nudge_desc2: "Your feedback trains our AI model to make VaultSphere better for everyone 🤖",
  tut_fill_survey: "Fill Survey 🚀", tut_maybe_later: "Maybe later →", tut_of: "of",
  // Survey questions
  survey_q1: "What best describes you?",
  survey_q1_o1: "Student", survey_q1_o2: "Developer", survey_q1_o3: "Designer",
  survey_q1_o4: "Researcher", survey_q1_o5: "Teacher / Professor", survey_q1_o6: "Other",
  survey_q2: "What year are you in?",
  survey_q2_o1: "1st Year", survey_q2_o2: "2nd Year", survey_q2_o3: "3rd Year",
  survey_q2_o4: "4th Year", survey_q2_o5: "Post Graduate", survey_q2_o6: "Working Professional",
  survey_q3: "What will you mainly use VaultSphere for?",
  survey_q3_o1: "Storing project files", survey_q3_o2: "Collaborating with teammates",
  survey_q3_o3: "Organising assignments", survey_q3_o4: "Storing certificates", survey_q3_o5: "All of the above",
  survey_q4: "Which features do you find most useful?",
  survey_q4_o1: "AI File Analysis", survey_q4_o2: "Team Collaboration",
  survey_q4_o3: "Analytics Dashboard", survey_q4_o4: "Version History",
  survey_q4_o5: "Certificate Storage", survey_q4_o6: "Public Share Links",
  survey_q5: "How would you rate VaultSphere overall?",
  survey_q6: "How do you like the design?",
  survey_q6_o1: "Love it! 😍", survey_q6_o2: "It's good 👍",
  survey_q6_o3: "Could be better 😐", survey_q6_o4: "Needs work 🔧",
  survey_q7: "What would you most like to see improved?",
  survey_q7_o1: "Faster performance", survey_q7_o2: "More AI features",
  survey_q7_o3: "Better mobile experience", survey_q7_o4: "More storage space",
  survey_q7_o5: "Dark mode", survey_q7_o6: "Nothing — it's great!",
  survey_q8: "Would you recommend VaultSphere to a friend?",
  survey_q8_o1: "Definitely yes! 🚀", survey_q8_o2: "Probably yes",
  survey_q8_o3: "Not sure", survey_q8_o4: "Probably not",
  survey_q9: "Any other feedback or suggestions?",
  survey_q9_placeholder: "Tell us what you think… (optional)",
  survey_select_all: "Select all that apply",
  survey_skip: "Skip survey →", survey_back: "← Back", survey_next: "Next →",
  survey_submit: "Submit 🚀", survey_submitting: "Submitting…",
  survey_done_title: "Thank you!", survey_done_desc: "Your feedback helps us make VaultSphere better. We really appreciate it!",
  survey_done_btn: "Go to Dashboard 🚀", survey_of: "of",
  // Share view
  sv_shared: "🔗 Shared Project", sv_sharedBy: "Shared by", sv_description: "Description",
  sv_techStack: "Tech Stack", sv_tags: "Tags", sv_attachedFile: "Attached File",
  sv_viewGithub: "🐙 View on GitHub", sv_downloadFile: "↓ Download File",
  sv_notFound: "Project not found or sharing has been disabled.",
  sv_loading: "Loading…", sv_watermark: "Made with VaultSphere · Secure · Elegant · Powerful",
  sv_goToVS: "← Go to VaultSphere",
  // Onboarding
  welcomeToVaultSphere: "Welcome to VaultSphere!",
  onboard1Desc: "Your personal project vault. Store, organise and share your work — all in one place.",
  createFirstProject: "Create your first folder",
  onboard2Desc: "Hit the '+ New Folder' button or press N anywhere. Add a title, description, files and tags.",
  collaborateWithTeammates: "Collaborate with teammates",
  onboard3Desc: "Go to Collaborate tab to search users and send invites. Accept or decline invites you receive.",
  findAnythingInstantly: "Find anything instantly",
  onboard4Desc: "Press / to open global search. Search across all your folders by title or tags.",
  next: "Next →", back: "← Back", letsGo: "Let's go! 🚀", skipTour: "Skip tour",
};

const HI = {
  login: "लॉगिन", email: "ईमेल पता", password: "पासवर्ड",
  loginButton: "लॉगिन करें", noAccount: "खाता नहीं है?", registerHere: "यहाँ रजिस्टर करें",
  loggingIn: "लॉगिन हो रहा है...", signingIn: "साइन इन हो रहा है…", loginTagline: "सुरक्षित · सुंदर · शक्तिशाली",
  forgotPasswordLink: "पासवर्ड भूल गए?",
  register: "रजिस्टर", fullName: "पूरा नाम", createAccount: "खाता बनाएं",
  registerButton: "रजिस्टर करें", registering: "रजिस्टर हो रहा है...", alreadyAccount: "पहले से खाता है?",
  loginHere: "यहाँ लॉगिन करें",
  passwordHint: "पासवर्ड में होना चाहिए: 8+ अक्षर, बड़े अक्षर, छोटे अक्षर, संख्या और विशेष अक्षर (@$!%*?&)",
  reg_step1: "चरण 1/2 — आपकी जानकारी", reg_step2: "चरण 2/2 — भाषा चुनें",
  reg_pickOnce: "एक बार चुनें — सेटिंग्स से कभी भी बदलें।",
  reg_next: "आगे →", reg_creating: "खाता बनाया जा रहा है…", reg_back: "← वापस",
  chooseLanguage: "अपनी पसंदीदा भाषा चुनें",
  verifyEmail: "ईमेल सत्यापित करें", enterOtp: "6 अंकों का OTP दर्ज करें", verifyButton: "OTP सत्यापित करें",
  verifying: "सत्यापित हो रहा है...", resendOtp: "OTP फिर से भेजें", sending: "भेजा जा रहा है...",
  otpExpiry: "OTP 10 मिनट में समाप्त होता है", otpSentTo: "OTP भेजा गया",
  selectLanguage: "भाषा चुनें", continue: "जारी रखें",
  forgotPassword: "पासवर्ड भूल गए?", resetPassword: "पासवर्ड रीसेट करें", sendOtp: "OTP भेजें",
  newPassword: "नया पासवर्ड", confirmPassword: "पासवर्ड की पुष्टि करें",
  fp_tagline: "पासवर्ड रीसेट करें", fp_step1: "चरण 1/2 — अपना ईमेल दर्ज करें",
  fp_emailPlaceholder: "आपका पंजीकृत ईमेल", fp_sendingOtp: "OTP भेजा जा रहा है…",
  fp_sendResetOtp: "रीसेट OTP भेजें", fp_step2: "चरण 2/2 — OTP और नया पासवर्ड दर्ज करें",
  fp_newPasswordPlaceholder: "नया पासवर्ड", fp_confirmPasswordPlaceholder: "पासवर्ड की पुष्टि करें",
  fp_resetting: "रीसेट हो रहा है…", fp_resetPassword: "पासवर्ड रीसेट करें",
  fp_rememberPassword: "पासवर्ड याद है?", fp_loginHere: "यहाँ लॉगिन करें",
  english: "अंग्रेज़ी", hindi: "हिंदी", telugu: "तेलुगु", tamil: "तमिल", malayalam: "मलयालम",
  dashboard: "डैशबोर्ड", myFolders: "मेरे फ़ोल्डर", sharedWithMe: "मेरे साथ साझा",
  newFolder: "+ नया फ़ोल्डर", searchFolders: "फ़ोल्डर खोजें...", noFoldersYet: "अभी कोई फ़ोल्डर नहीं",
  createFirstFolder: "शुरू करने के लिए अपना पहला फ़ोल्डर बनाएं।",
  createFirstFolderBtn: "+ पहला फ़ोल्डर बनाएं",
  totalFolders: "कुल फ़ोल्डर", totalFiles: "कुल फ़ाइलें", daysActive: "सक्रिय दिन", badgesEarned: "बैज अर्जित",
  folderName: "फ़ोल्डर का नाम *", description: "विवरण", tags: "टैग (अल्पविराम से अलग)",
  status: "स्थिति", dueDate: "देय तिथि", changeNote: "बदलाव नोट (वैकल्पिक)",
  addFiles: "फ़ाइलें जोड़ें (वैकल्पिक)", dropFiles: "क्लिक करें या फ़ाइलें खींचें",
  anyFileType: "कोई भी फ़ाइल प्रकार · अधिकतम 25MB",
  saveChanges: "बदलाव सहेजें", cancel: "रद्द करें",
  createFolder: "📁 फ़ोल्डर बनाएं", createFolderBtn: "📁 फ़ोल्डर बनाएं",
  editFolder: "✏️ फ़ोल्डर संपादित करें", deleteFolder: "🗑️ हटाएं",
  share: "🔗 साझा करें", sharingOn: "🔗 साझाकरण चालू",
  sharingDisabled: "साझाकरण बंद", sharingEnabled: "साझाकरण सक्षम — लिंक वाला कोई भी देख सकता है",
  saving: "सहेजा जा रहा है…",
  files: "फ़ाइलें", noFilesYet: "अभी कोई फ़ाइल नहीं — नीचे अपलोड करें",
  clickToView: "देखने के लिए क्लिक करें · ↓ डाउनलोड",
  dropFilesHere: "फ़ाइलें यहाँ छोड़ें या अपलोड करने के लिए क्लिक करें",
  view: "देखें", edit: "संपादित करें", download: "↓", delete: "✕", aiAnalyse: "🤖 AI",
  uploadMoreFiles: "और फ़ाइलें अपलोड करें",
  details: "विवरण", comments: "टिप्पणियाँ", activity: "गतिविधि", history: "इतिहास",
  active: "सक्रिय", inProgress: "प्रगति में", completed: "पूर्ण", onHold: "रोका गया", archived: "संग्रहीत",
  allStatuses: "सभी स्थितियाँ",
  publicShareLink: "सार्वजनिक शेयर लिंक", tags2: "टैग",
  noCommentsYet: "अभी कोई टिप्पणी नहीं — @ टाइप करें!", addComment: "टिप्पणी जोड़ें", post: "पोस्ट",
  noActivityYet: "अभी कोई गतिविधि नहीं।", noVersionHistory: "अभी कोई संस्करण इतिहास नहीं।",
  historyAutoSaves: "संपादित करने पर इतिहास स्वचालित रूप से सहेजता है।",
  restore: "↩ पुनर्स्थापित करें", savedVersions: "सहेजे गए संस्करण", current: "वर्तमान",
  restoreVersion: "इस संस्करण पर पुनर्स्थापित करें?",
  recycleBin: "रीसायकल बिन", restoreOrDelete: "प्रोजेक्ट पुनर्स्थापित या स्थायी रूप से हटाएं",
  binIsEmpty: "रीसायकल बिन खाली है", deletedAppearHere: "हटाए गए प्रोजेक्ट यहाँ दिखाई देंगे।",
  restoreProject: "↩ पुनर्स्थापित करें", deleteForever: "✕ हमेशा के लिए हटाएं",
  collaboration: "सहयोग", inviteTeammates: "टीम के सदस्यों को आमंत्रित करें",
  sendInvite: "✉️ आमंत्रण भेजें", received: "📬 प्राप्त", sent: "📤 भेजा गया",
  findUsers: "🔍 उपयोगकर्ता खोजें", typeToSearch: "उपयोगकर्ता खोजने के लिए टाइप करें",
  emailAddress: "ईमेल पता *", project: "प्रोजेक्ट", role: "भूमिका",
  viewer: "दर्शक", editor: "संपादक", admin: "व्यवस्थापक",
  sendInviteBtn: "आमंत्रण भेजें", sending2: "भेज रहा है…",
  noInvitationsReceived: "कोई आमंत्रण प्राप्त नहीं हुए", noInvitesSent: "अभी कोई आमंत्रण नहीं भेजा",
  accept: "स्वीकार करें ✅", decline: "अस्वीकार करें ❌", cancel2: "रद्द करें",
  inviteAccepted: "स्वीकृत", inviteDeclined: "अस्वीकृत", invitePending: "लंबित",
  analytics: "विश्लेषण", personalDashboard: "आपका व्यक्तिगत VaultSphere गतिविधि डैशबोर्ड",
  activityHeatmap: "गतिविधि हीटमैप", lastYear: "पिछले एक साल में फ़ोल्डर निर्माण + फ़ाइल अपलोड",
  filesUploaded: "अपलोड की गई फ़ाइलें", foldersCreated: "बनाए गए फ़ोल्डर",
  last6Months: "पिछले 6 महीने", folderStatus: "फ़ोल्डर स्थिति", breakdownByStatus: "स्थिति के अनुसार",
  mostActiveFolders: "सबसे सक्रिय फ़ोल्डर", byNumberOfFiles: "फ़ाइलों की संख्या के अनुसार",
  noFoldersYet2: "अभी कोई फ़ोल्डर नहीं", badgesEarned2: "अर्जित बैज 🏆",
  badgesUnlocked: "6 में से बैज अनलॉक", refresh: "↻ रीफ्रेश",
  teams: "टीमें", createTeams: "टीमें बनाएं और सहयोग के लिए सदस्यों को आमंत्रित करें",
  newTeam: "+ नई टीम", createNewTeam: "नई टीम बनाएं",
  teamName: "टीम का नाम जैसे डिज़ाइन स्क्वाड, बैकएंड टीम…",
  createTeamBtn: "टीम बनाएं", noTeamsYet: "अभी कोई टीम नहीं",
  createTeamSub: "साझा प्रोजेक्ट पर सहयोग के लिए एक टीम बनाएं।",
  createFirstTeam: "+ पहली टीम बनाएं",
  members: "सदस्य", inviteSomeone: "किसी को आमंत्रित करें",
  enterEmail: "ईमेल पता दर्ज करें…", addBtn: "+ जोड़ें", adding: "जोड़ रहा है…",
  mustHaveAccount: "व्यक्ति के पास पहले से VaultSphere खाता होना चाहिए",
  deleteTeam: "🗑️ टीम हटाएं", remove: "हटाएं", owner: "👑 मालिक", you: "आप",
  certificates: "प्रमाण पत्र", certificatesSubtitle: "अपने सभी प्रमाण पत्र एक ही जगह रखें",
  addCertificate: "+ प्रमाण पत्र जोड़ें", addAnotherCertificate: "और प्रमाण पत्र जोड़ें",
  addFirstCertificate: "+ पहला प्रमाण पत्र जोड़ें",
  noCertificatesYet: "अभी कोई प्रमाण पत्र नहीं",
  noCertSub: "Coursera, NPTEL, Google, Udemy से प्रमाण पत्र जोड़ें।",
  certName: "प्रमाण पत्र का नाम *", certNamePlaceholder: "जैसे AWS Cloud Practitioner…",
  certIssuer: "जारी करने वाला", certIssuerPlaceholder: "जैसे Coursera, NPTEL, Google…",
  certDate: "जारी करने की तिथि", certTags: "टैग (अल्पविराम से अलग)",
  certFile: "प्रमाण पत्र फ़ाइल अपलोड करें (PDF/Image)",
  certAdding: "जोड़ा जा रहा है…", certAddBtn: "🏆 प्रमाण पत्र जोड़ें",
  totalCertificates: "कुल प्रमाण पत्र", filesStored: "संग्रहीत फ़ाइलें", skillsTagged: "टैग किए गए कौशल",
  issuedBy: "जारी करने वाला:",
  survey: "सर्वेक्षण", shareFeedback: "अपनी प्रतिक्रिया साझा करें",
  surveyBannerTitle: "VaultSphere को बेहतर बनाने में मदद करें!",
  surveyBannerSub: "केवल 2 मिनट · आपकी प्रतिक्रिया AI मॉडल को प्रशिक्षित करती है 🤖",
  takeSurvey: "सर्वेक्षण करें →", surveyAlreadyDone: "✅ आपने सर्वेक्षण पहले ही पूरा किया — धन्यवाद!",
  startSurvey: "सर्वेक्षण शुरू करें →", helpUsImprove: "VaultSphere को बेहतर बनाने में मदद करें",
  surveyDesc: "2 मिनट में अपनी प्रतिक्रिया साझा करें।",
  settings: "सेटिंग्स", language: "भाषा", changeLanguage: "भाषा बदलें",
  currentLanguage: "वर्तमान भाषा", signOut: "साइन आउट",
  signOutDesc: "आपको साइन आउट किया जाएगा और लॉगिन पेज पर वापस भेजा जाएगा.", signOutBtn: "साइन आउट",
  managePreferences: "अपनी प्राथमिकताएं प्रबंधित करें",
  changeLangDesc: "भाषा बदलें — तुरंत हर जगह लागू होती है",
  accountSettings: "खाता", accountDesc: "अपना नाम या पासवर्ड प्रोफ़ाइल पेज से अपडेट करें।",
  openProfile: "प्रोफ़ाइल खोलें →", tutorialSettings: "ट्यूटोरियल",
  tutorialDesc: "VaultSphere सुविधाओं को सीखने के लिए ट्यूटोरियल फिर से देखें।",
  viewTutorial: "ट्यूटोरियल देखें →",
  profile: "प्रोफ़ाइल",
  notifications: "सूचनाएं", allCaughtUp: "सब ठीक है! कोई सूचना नहीं।",
  markAllRead: "सभी पढ़े हुए चिह्नित करें", clearAll: "सब साफ करें",
  searchPlaceholder: "प्रोजेक्ट, टैग खोजें…",
  recentProjects: "हाल के प्रोजेक्ट", noTechStack: "कोई टेक स्टैक नहीं", noTags: "कोई टैग नहीं",
  results: "परिणाम", navigate: "नेविगेट करें", open: "खोलें", close: "बंद करें",
  searchNoResults: "के लिए कोई परिणाम नहीं",
  pinFolder: "📌 पिन", unpinFolder: "अनपिन", pinnedFolders: "पिन किए गए फ़ोल्डर",
  noPinnedFolders: "अभी कोई पिन किया गया फ़ोल्डर नहीं", pinHint: "त्वरित पहुँच के लिए अधिकतम 3 फ़ोल्डर पिन करें",
  editorSaving: "सहेजा जा रहा है…", editorSave: "💾 सहेजें",
  loadingFile: "फ़ाइल सामग्री लोड हो रही है…", tabHint: "Tab = 2 स्पेस · Ctrl+S सहेजता है",
  fileAppearEmpty: "फ़ाइल खाली लगती है", tryReupload: "फ़ाइल फिर से अपलोड करने का प्रयास करें",
  analysingFile: "AI के साथ फ़ाइल का विश्लेषण हो रहा है…", aiMayTake: "इसमें कुछ सेकंड लग सकते हैं",
  aiSummary: "📋 सारांश", aiKeyPoints: "🔑 मुख्य बिंदु", aiComplexity: "⚡ जटिलता",
  aiSuggestions: "💡 सुझाव", aiTags: "🏷️ सुझाए गए टैग",
  logout: "लॉगआउट", logoutConfirm: "क्या आप वाकई लॉगआउट करना चाहते हैं?",
  deleteConfirm: "रीसायकल बिन में भेजें?", deleteFileConfirm: "यह फ़ाइल हटाएं?",
  deleteTeamConfirm: "टीम हटाएं? यह पूर्ववत नहीं किया जा सकता।",
  permanentDeleteConfirm: "स्थायी रूप से हटाएं? यह पूर्ववत नहीं किया जा सकता।",
  page: "पृष्ठ", of: "का", prev: "← पिछला", nextPage: "अगला →",
  loading: "लोड हो रहा है…", error: "त्रुटि", success: "सफलता",
  overdue: "अतिदेय", dueToday: "आज देय!", dueIn: "में देय",
  tut_step1_title: "अपना पहला फ़ोल्डर बनाएं",
  tut_step1_desc: "VaultSphere आपके काम को फ़ोल्डर में व्यवस्थित करता है। प्रत्येक फ़ोल्डर में कई फ़ाइलें हो सकती हैं।",
  tut_step1_tip: "💡 डैशबोर्ड पर कहीं भी N दबाएं",
  tut_step2_title: "फ़ोल्डर में फ़ाइलें अपलोड करें",
  tut_step2_desc: "कोई भी फ़ोल्डर खोलें और फ़ाइलें डालें। PDF, कोड फ़ाइलें, चित्र — कोई भी फ़ाइल प्रकार 25MB तक।",
  tut_step2_tip: "💡 एक साथ कई फ़ाइलें अपलोड करें",
  tut_step3_title: "AI फ़ाइल विश्लेषण",
  tut_step3_desc: "किसी भी फ़ाइल पर 🤖 AI बटन क्लिक करें — सारांश, मुख्य बिंदु, जटिलता और सुझाए गए टैग।",
  tut_step3_tip: "💡 कोड फ़ाइलें, PDF, टेक्स्ट फ़ाइलों पर काम करता है",
  tut_step4_title: "टीम के साथ सहयोग करें",
  tut_step4_desc: "सहयोग टैब पर जाएं और टीम के सदस्यों को आमंत्रित करें। भूमिका के आधार पर पहुँच दें।",
  tut_step4_tip: "💡 स्वीकृत आमंत्रण 'मेरे साथ साझा' टैब में दिखते हैं",
  tut_step5_title: "प्रमाण पत्र संग्रहीत करें",
  tut_step5_desc: "Coursera, NPTEL या Google का प्रमाण पत्र मिला? प्रमाण पत्र टैब में संग्रहीत करें!",
  tut_step5_tip: "💡 प्रमाण पत्र स्वचालित रूप से टैग और खोजने योग्य हैं",
  tut_step6_title: "अपना विश्लेषण ट्रैक करें",
  tut_step6_desc: "विश्लेषण टैब GitHub-स्टाइल हीटमैप, मासिक फ़ाइलें और बैज दिखाता है।",
  tut_step6_tip: "💡 VaultSphere का उपयोग करके बैज अर्जित करें",
  tut_skip: "छोड़ें →", tut_next: "आगे →", tut_back: "← वापस", tut_letsgo: "चलो शुरू करें! 🚀",
  tut_nudge_title: "एक आखिरी बात!", tut_nudge_desc1: "क्या आप एक त्वरित 2 मिनट का सर्वेक्षण भर सकते हैं?",
  tut_nudge_desc2: "आपकी प्रतिक्रिया हमारे AI मॉडल को प्रशिक्षित करती है 🤖",
  tut_fill_survey: "सर्वेक्षण भरें 🚀", tut_maybe_later: "बाद में →", tut_of: "का",
  survey_q1: "आप खुद को कैसे परिभाषित करते हैं?",
  survey_q1_o1: "छात्र", survey_q1_o2: "डेवलपर", survey_q1_o3: "डिज़ाइनर",
  survey_q1_o4: "शोधकर्ता", survey_q1_o5: "शिक्षक / प्रोफेसर", survey_q1_o6: "अन्य",
  survey_q2: "आप किस वर्ष में हैं?",
  survey_q2_o1: "पहला वर्ष", survey_q2_o2: "दूसरा वर्ष", survey_q2_o3: "तीसरा वर्ष",
  survey_q2_o4: "चौथा वर्ष", survey_q2_o5: "स्नातकोत्तर", survey_q2_o6: "कार्यरत पेशेवर",
  survey_q3: "आप VaultSphere मुख्य रूप से किसलिए उपयोग करेंगे?",
  survey_q3_o1: "प्रोजेक्ट फ़ाइलें संग्रहीत करना", survey_q3_o2: "टीम के साथ सहयोग",
  survey_q3_o3: "असाइनमेंट व्यवस्थित करना", survey_q3_o4: "प्रमाण पत्र संग्रहीत करना", survey_q3_o5: "उपरोक्त सभी",
  survey_q4: "आप कौन सी सुविधाएं सबसे उपयोगी पाते हैं?",
  survey_q4_o1: "AI फ़ाइल विश्लेषण", survey_q4_o2: "टीम सहयोग",
  survey_q4_o3: "विश्लेषण डैशबोर्ड", survey_q4_o4: "संस्करण इतिहास",
  survey_q4_o5: "प्रमाण पत्र भंडारण", survey_q4_o6: "सार्वजनिक शेयर लिंक",
  survey_q5: "आप VaultSphere को कुल मिलाकर कैसे रेट करेंगे?",
  survey_q6: "आप डिज़ाइन को कैसे पसंद करते हैं?",
  survey_q6_o1: "बहुत पसंद है! 😍", survey_q6_o2: "अच्छा है 👍",
  survey_q6_o3: "बेहतर हो सकता है 😐", survey_q6_o4: "और काम चाहिए 🔧",
  survey_q7: "आप सबसे ज़्यादा क्या सुधरवाना चाहेंगे?",
  survey_q7_o1: "तेज़ प्रदर्शन", survey_q7_o2: "अधिक AI सुविधाएं",
  survey_q7_o3: "बेहतर मोबाइल अनुभव", survey_q7_o4: "अधिक स्टोरेज स्पेस",
  survey_q7_o5: "डार्क मोड", survey_q7_o6: "कुछ नहीं — बहुत अच्छा है!",
  survey_q8: "क्या आप VaultSphere को किसी मित्र को अनुशंसित करेंगे?",
  survey_q8_o1: "निश्चित रूप से हाँ! 🚀", survey_q8_o2: "शायद हाँ", survey_q8_o3: "निश्चित नहीं", survey_q8_o4: "शायद नहीं",
  survey_q9: "कोई अन्य प्रतिक्रिया या सुझाव?", survey_q9_placeholder: "हमें बताएं आप क्या सोचते हैं… (वैकल्पिक)",
  survey_select_all: "सभी लागू विकल्प चुनें",
  survey_skip: "सर्वेक्षण छोड़ें →", survey_back: "← वापस", survey_next: "आगे →",
  survey_submit: "जमा करें 🚀", survey_submitting: "जमा हो रहा है…",
  survey_done_title: "धन्यवाद!", survey_done_desc: "आपकी प्रतिक्रिया हमें VaultSphere बेहतर बनाने में मदद करती है।",
  survey_done_btn: "डैशबोर्ड पर जाएं 🚀", survey_of: "का",
  sv_shared: "🔗 साझा प्रोजेक्ट", sv_sharedBy: "द्वारा साझा", sv_description: "विवरण",
  sv_techStack: "टेक स्टैक", sv_tags: "टैग", sv_attachedFile: "संलग्न फ़ाइल",
  sv_viewGithub: "🐙 GitHub पर देखें", sv_downloadFile: "↓ फ़ाइल डाउनलोड करें",
  sv_notFound: "प्रोजेक्ट नहीं मिला या साझाकरण अक्षम है।",
  sv_loading: "लोड हो रहा है…", sv_watermark: "VaultSphere के साथ बनाया गया",
  sv_goToVS: "← VaultSphere पर जाएं",
  welcomeToVaultSphere: "VaultSphere में आपका स्वागत है!",
  onboard1Desc: "आपका व्यक्तिगत प्रोजेक्ट वॉल्ट। अपना काम एक ही जगह स्टोर, व्यवस्थित और साझा करें।",
  createFirstProject: "अपना पहला फ़ोल्डर बनाएं",
  onboard2Desc: "'+ नया फ़ोल्डर' बटन दबाएं या कहीं भी N दबाएं।",
  collaborateWithTeammates: "साथियों के साथ सहयोग करें",
  onboard3Desc: "उपयोगकर्ताओं को खोजने और आमंत्रण भेजने के लिए सहयोग टैब पर जाएं।",
  findAnythingInstantly: "तुरंत कुछ भी खोजें",
  onboard4Desc: "वैश्विक खोज खोलने के लिए / दबाएं।",
  next: "अगला →", back: "← वापस", letsGo: "चलो शुरू करें! 🚀", skipTour: "टूर छोड़ें",
};

const TE = {
  login: "లాగిన్", email: "ఇమెయిల్ చిరునామా", password: "పాస్‌వర్డ్",
  loginButton: "లాగిన్ చేయండి", noAccount: "ఖాతా లేదా?", registerHere: "ఇక్కడ నమోదు చేయండి",
  loggingIn: "లాగిన్ అవుతోంది...", signingIn: "సైన్ ఇన్ అవుతోంది…", loginTagline: "సురక్షిత · సొగసైన · శక్తివంతమైన",
  forgotPasswordLink: "పాస్‌వర్డ్ మర్చిపోయారా?",
  register: "నమోదు", fullName: "పూర్తి పేరు", createAccount: "ఖాతా సృష్టించండి",
  registerButton: "నమోదు చేయండి", registering: "నమోదు అవుతోంది...", alreadyAccount: "ఇప్పటికే ఖాతా ఉందా?",
  loginHere: "ఇక్కడ లాగిన్ చేయండి",
  passwordHint: "పాస్‌వర్డ్‌లో ఉండాలి: 8+ అక్షరాలు, పెద్ద అక్షరాలు, చిన్న అక్షరాలు, సంఖ్య మరియు ప్రత్యేక అక్షరం (@$!%*?&)",
  reg_step1: "దశ 1/2 — మీ వివరాలు", reg_step2: "దశ 2/2 — భాష ఎంచుకోండి",
  reg_pickOnce: "ఒకసారి ఎంచుకోండి — సెట్టింగ్‌ల నుండి మార్చవచ్చు.",
  reg_next: "తదుపరి →", reg_creating: "ఖాతా సృష్టిస్తోంది…", reg_back: "← వెనుక",
  chooseLanguage: "మీకు నచ్చిన భాషను ఎంచుకోండి",
  verifyEmail: "ఇమెయిల్ ధృవీకరించండి", enterOtp: "6 అంకెల OTP నమోదు చేయండి", verifyButton: "OTP ధృవీకరించండి",
  verifying: "ధృవీకరిస్తోంది...", resendOtp: "OTP మళ్ళీ పంపండి", sending: "పంపుతోంది...",
  otpExpiry: "OTP 10 నిమిషాల్లో గడువు తీరుతుంది", otpSentTo: "OTP పంపబడింది",
  selectLanguage: "భాషను ఎంచుకోండి", continue: "కొనసాగించు",
  forgotPassword: "పాస్‌వర్డ్ మర్చిపోయారా?", resetPassword: "పాస్‌వర్డ్ రీసెట్ చేయండి", sendOtp: "OTP పంపండి",
  newPassword: "కొత్త పాస్‌వర్డ్", confirmPassword: "పాస్‌వర్డ్ నిర్ధారించండి",
  fp_tagline: "పాస్‌వర్డ్ రీసెట్ చేయండి", fp_step1: "దశ 1/2 — మీ ఇమెయిల్ నమోదు చేయండి",
  fp_emailPlaceholder: "మీ నమోదిత ఇమెయిల్", fp_sendingOtp: "OTP పంపుతోంది…",
  fp_sendResetOtp: "రీసెట్ OTP పంపండి", fp_step2: "దశ 2/2 — OTP మరియు కొత్త పాస్‌వర్డ్ నమోదు చేయండి",
  fp_newPasswordPlaceholder: "కొత్త పాస్‌వర్డ్", fp_confirmPasswordPlaceholder: "పాస్‌వర్డ్ నిర్ధారించండి",
  fp_resetting: "రీసెట్ అవుతోంది…", fp_resetPassword: "పాస్‌వర్డ్ రీసెట్ చేయండి",
  fp_rememberPassword: "పాస్‌వర్డ్ గుర్తుందా?", fp_loginHere: "ఇక్కడ లాగిన్ చేయండి",
  english: "ఇంగ్లీష్", hindi: "హిందీ", telugu: "తెలుగు", tamil: "తమిళం", malayalam: "మలయాళం",
  dashboard: "డాష్‌బోర్డ్", myFolders: "నా ఫోల్డర్లు", sharedWithMe: "నాతో భాగస్వామ్యం",
  newFolder: "+ కొత్త ఫోల్డర్", searchFolders: "ఫోల్డర్లు వెతకండి...", noFoldersYet: "ఇంకా ఫోల్డర్లు లేవు",
  createFirstFolder: "ప్రారంభించడానికి మీ మొదటి ఫోల్డర్ సృష్టించండి.",
  createFirstFolderBtn: "+ మొదటి ఫోల్డర్ సృష్టించండి",
  totalFolders: "మొత్తం ఫోల్డర్లు", totalFiles: "మొత్తం ఫైళ్లు", daysActive: "చురుకైన రోజులు", badgesEarned: "బ్యాడ్జ్‌లు సంపాదించారు",
  folderName: "ఫోల్డర్ పేరు *", description: "వివరణ", tags: "ట్యాగ్‌లు (కామాతో వేరు చేయండి)",
  status: "స్థితి", dueDate: "గడువు తేదీ", changeNote: "మార్పు గమనిక (ఐచ్ఛికం)",
  addFiles: "ఫైళ్లు జోడించండి (ఐచ్ఛికం)", dropFiles: "క్లిక్ చేయండి లేదా ఫైళ్లు లాగండి",
  anyFileType: "ఏ ఫైల్ రకమైనా · గరిష్టం 25MB",
  saveChanges: "మార్పులు సేవ్ చేయండి", cancel: "రద్దు చేయండి",
  createFolder: "📁 ఫోల్డర్ సృష్టించండి", createFolderBtn: "📁 ఫోల్డర్ సృష్టించండి",
  editFolder: "✏️ ఫోల్డర్ సవరించండి", deleteFolder: "🗑️ తొలగించు",
  share: "🔗 భాగస్వామ్యం", sharingOn: "🔗 భాగస్వామ్యం ఆన్",
  sharingDisabled: "భాగస్వామ్యం నిలిపివేయబడింది", sharingEnabled: "భాగస్వామ్యం సక్రియం — లింక్ ఉన్న ఎవరైనా చూడవచ్చు",
  saving: "సేవ్ అవుతోంది…",
  files: "ఫైళ్లు", noFilesYet: "ఇంకా ఫైళ్లు లేవు — క్రింద అప్‌లోడ్ చేయండి",
  clickToView: "చూడడానికి క్లిక్ చేయండి · ↓ డౌన్‌లోడ్",
  dropFilesHere: "ఫైళ్లు ఇక్కడ వదలండి లేదా అప్‌లోడ్ చేయడానికి క్లిక్ చేయండి",
  view: "చూడు", edit: "సవరించు", download: "↓", delete: "✕", aiAnalyse: "🤖 AI",
  uploadMoreFiles: "మరిన్ని ఫైళ్లు అప్‌లోడ్ చేయండి",
  details: "వివరాలు", comments: "వ్యాఖ్యలు", activity: "కార్యకలాపం", history: "చరిత్ర",
  active: "చురుకైన", inProgress: "అభివృద్ధిలో", completed: "పూర్తయింది", onHold: "నిలిపివేయబడింది", archived: "సంగ్రహించబడింది",
  allStatuses: "అన్ని స్థితులు",
  publicShareLink: "పబ్లిక్ షేర్ లింక్", tags2: "ట్యాగ్‌లు",
  noCommentsYet: "ఇంకా వ్యాఖ్యలు లేవు — @ టైప్ చేయండి!", addComment: "వ్యాఖ్య జోడించండి", post: "పోస్ట్",
  noActivityYet: "ఇంకా కార్యకలాపం లేదు.", noVersionHistory: "ఇంకా వెర్షన్ చరిత్ర లేదు.",
  historyAutoSaves: "సవరించినప్పుడు చరిత్ర స్వయంచాలకంగా సేవ్ అవుతుంది.",
  restore: "↩ పునరుద్ధరించు", savedVersions: "సేవ్ చేసిన వెర్షన్లు", current: "ప్రస్తుత",
  restoreVersion: "ఈ వెర్షన్‌కు పునరుద్ధరించాలా?",
  recycleBin: "రీసైకిల్ బిన్", restoreOrDelete: "పునరుద్ధరించండి లేదా శాశ్వతంగా తొలగించండి",
  binIsEmpty: "రీసైకిల్ బిన్ ఖాళీగా ఉంది", deletedAppearHere: "తొలగించిన ప్రాజెక్టులు ఇక్కడ కనిపిస్తాయి.",
  restoreProject: "↩ పునరుద్ధరించు", deleteForever: "✕ శాశ్వతంగా తొలగించు",
  collaboration: "సహకారం", inviteTeammates: "జట్టు సభ్యులను ఆహ్వానించండి",
  sendInvite: "✉️ ఆహ్వానం పంపండి", received: "📬 అందింది", sent: "📤 పంపారు",
  findUsers: "🔍 వినియోగదారులను కనుగొనండి", typeToSearch: "వినియోగదారులను వెతకడానికి టైప్ చేయండి",
  emailAddress: "ఇమెయిల్ చిరునామా *", project: "ప్రాజెక్ట్", role: "పాత్ర",
  viewer: "వీక్షకుడు", editor: "సంపాదకుడు", admin: "నిర్వాహకుడు",
  sendInviteBtn: "ఆహ్వానం పంపండి", sending2: "పంపుతోంది…",
  noInvitationsReceived: "ఆహ్వానాలు ఏవీ అందలేదు", noInvitesSent: "ఇంకా ఆహ్వానాలు పంపలేదు",
  accept: "అంగీకరించు ✅", decline: "తిరస్కరించు ❌", cancel2: "రద్దు",
  inviteAccepted: "అంగీకరించబడింది", inviteDeclined: "తిరస్కరించబడింది", invitePending: "పెండింగ్",
  analytics: "విశ్లేషణలు", personalDashboard: "మీ వ్యక్తిగత VaultSphere కార్యకలాప డాష్‌బోర్డ్",
  activityHeatmap: "కార్యకలాప హీట్‌మ్యాప్", lastYear: "గత సంవత్సరంలో ఫోల్డర్ సృష్టి + ఫైల్ అప్‌లోడ్‌లు",
  filesUploaded: "అప్‌లోడ్ చేసిన ఫైళ్లు", foldersCreated: "సృష్టించిన ఫోల్డర్లు",
  last6Months: "గత 6 నెలలు", folderStatus: "ఫోల్డర్ స్థితి", breakdownByStatus: "స్థితి ప్రకారం",
  mostActiveFolders: "అత్యంత చురుకైన ఫోల్డర్లు", byNumberOfFiles: "ఫైళ్ల సంఖ్య ప్రకారం",
  noFoldersYet2: "ఇంకా ఫోల్డర్లు లేవు", badgesEarned2: "సంపాదించిన బ్యాడ్జ్‌లు 🏆",
  badgesUnlocked: "6 లో బ్యాడ్జ్‌లు అన్‌లాక్", refresh: "↻ రిఫ్రెష్",
  teams: "జట్లు", createTeams: "జట్లు సృష్టించి సహకారానికి సభ్యులను ఆహ్వానించండి",
  newTeam: "+ కొత్త జట్టు", createNewTeam: "కొత్త జట్టు సృష్టించండి",
  teamName: "జట్టు పేరు ఉదా. డిజైన్ స్క్వాడ్…",
  createTeamBtn: "జట్టు సృష్టించండి", noTeamsYet: "ఇంకా జట్లు లేవు",
  createTeamSub: "భాగస్వామ్య ప్రాజెక్టులపై సహకరించడానికి జట్టు సృష్టించండి.",
  createFirstTeam: "+ మొదటి జట్టు సృష్టించండి",
  members: "సభ్యులు", inviteSomeone: "ఎవరినైనా ఆహ్వానించండి",
  enterEmail: "ఇమెయిల్ చిరునామా నమోదు చేయండి…", addBtn: "+ జోడించు", adding: "జోడిస్తోంది…",
  mustHaveAccount: "వ్యక్తికి ఇప్పటికే VaultSphere ఖాతా ఉండాలి",
  deleteTeam: "🗑️ జట్టు తొలగించు", remove: "తొలగించు", owner: "👑 యజమాని", you: "మీరు",
  certificates: "సర్టిఫికెట్లు", certificatesSubtitle: "మీ అన్ని సర్టిఫికెట్లు ఒకే చోట నిల్వ చేయండి",
  addCertificate: "+ సర్టిఫికెట్ జోడించండి", addAnotherCertificate: "మరో సర్టిఫికెట్ జోడించండి",
  addFirstCertificate: "+ మొదటి సర్టిఫికెట్ జోడించండి",
  noCertificatesYet: "ఇంకా సర్టిఫికెట్లు లేవు",
  noCertSub: "Coursera, NPTEL, Google, Udemy నుండి మీ సర్టిఫికెట్లు జోడించండి.",
  certName: "సర్టిఫికెట్ పేరు *", certNamePlaceholder: "ఉదా. AWS Cloud Practitioner…",
  certIssuer: "జారీ చేసినవారు", certIssuerPlaceholder: "ఉదా. Coursera, NPTEL, Google…",
  certDate: "జారీ తేదీ", certTags: "ట్యాగ్‌లు (కామాతో వేరు చేయండి)",
  certFile: "సర్టిఫికెట్ ఫైల్ అప్‌లోడ్ చేయండి (PDF/Image)",
  certAdding: "జోడిస్తోంది…", certAddBtn: "🏆 సర్టిఫికెట్ జోడించండి",
  totalCertificates: "మొత్తం సర్టిఫికెట్లు", filesStored: "నిల్వ చేసిన ఫైళ్లు", skillsTagged: "ట్యాగ్ చేసిన నైపుణ్యాలు",
  issuedBy: "జారీ చేసినవారు:",
  survey: "సర్వే", shareFeedback: "మీ అభిప్రాయం పంచుకోండి",
  surveyBannerTitle: "VaultSphere మెరుగుపరచడంలో సహాయపడండి!",
  surveyBannerSub: "కేవలం 2 నిమిషాలు · మీ అభిప్రాయం AI మోడల్‌ను శిక్షిస్తుంది 🤖",
  takeSurvey: "సర్వే చేయండి →", surveyAlreadyDone: "✅ మీరు ఇప్పటికే సర్వే పూర్తి చేశారు — ధన్యవాదాలు!",
  startSurvey: "సర్వే ప్రారంభించండి →", helpUsImprove: "VaultSphere మెరుగుపరచడంలో సహాయపడండి",
  surveyDesc: "2 నిమిషాల్లో మీ అభిప్రాయం పంచుకోండి.",
  settings: "సెట్టింగ్‌లు", language: "భాష", changeLanguage: "భాష మార్చండి",
  currentLanguage: "ప్రస్తుత భాష", signOut: "సైన్ అవుట్",
  signOutDesc: "మీరు సైన్ అవుట్ చేయబడతారు మరియు లాగిన్ పేజీకి తిరిగి వెళ్తారు.", signOutBtn: "సైన్ అవుట్",
  managePreferences: "మీ ప్రాధాన్యతలు నిర్వహించండి",
  changeLangDesc: "భాష మార్చండి — వెంటనే అన్ని చోట్లా వర్తిస్తుంది",
  accountSettings: "ఖాతా", accountDesc: "మీ పేరు లేదా పాస్‌వర్డ్ ప్రొఫైల్ పేజీ నుండి అప్‌డేట్ చేయండి.",
  openProfile: "ప్రొఫైల్ తెరవండి →", tutorialSettings: "ట్యుటోరియల్",
  tutorialDesc: "VaultSphere ఫీచర్లు నేర్చుకోవడానికి ట్యుటోరియల్ మళ్ళీ చూడండి.",
  viewTutorial: "ట్యుటోరియల్ చూడండి →",
  profile: "ప్రొఫైల్",
  notifications: "నోటిఫికేషన్లు", allCaughtUp: "అన్నీ సరే! నోటిఫికేషన్లు లేవు.",
  markAllRead: "అన్నీ చదివినట్లు గుర్తించు", clearAll: "అన్నీ తొలగించు",
  searchPlaceholder: "ప్రాజెక్టులు, ట్యాగ్‌లు వెతకండి…",
  recentProjects: "ఇటీవలి ప్రాజెక్టులు", noTechStack: "టెక్ స్టాక్ లేదు", noTags: "ట్యాగ్‌లు లేవు",
  results: "ఫలితాలు", navigate: "నావిగేట్ చేయండి", open: "తెరవండి", close: "మూసివేయండి",
  searchNoResults: "కు ఫలితాలు లేవు",
  pinFolder: "📌 పిన్", unpinFolder: "అన్‌పిన్", pinnedFolders: "పిన్ చేసిన ఫోల్డర్లు",
  noPinnedFolders: "ఇంకా పిన్ చేసిన ఫోల్డర్లు లేవు", pinHint: "త్వరిత యాక్సెస్ కోసం గరిష్టంగా 3 ఫోల్డర్లు పిన్ చేయండి",
  editorSaving: "సేవ్ అవుతోంది…", editorSave: "💾 సేవ్",
  loadingFile: "ఫైల్ కంటెంట్ లోడ్ అవుతోంది…", tabHint: "Tab = 2 స్పేస్ · Ctrl+S సేవ్ చేస్తుంది",
  fileAppearEmpty: "ఫైల్ ఖాళీగా కనిపిస్తోంది", tryReupload: "ఫైల్ మళ్ళీ అప్‌లోడ్ చేయడానికి ప్రయత్నించండి",
  analysingFile: "AI తో ఫైల్ విశ్లేషిస్తోంది…", aiMayTake: "ఇది కొన్ని సెకన్లు పట్టవచ్చు",
  aiSummary: "📋 సారాంశం", aiKeyPoints: "🔑 ముఖ్య అంశాలు", aiComplexity: "⚡ సంక్లిష్టత",
  aiSuggestions: "💡 సూచనలు", aiTags: "🏷️ సూచించిన ట్యాగ్‌లు",
  logout: "లాగ్అవుట్", logoutConfirm: "మీరు నిజంగా లాగ్అవుట్ చేయాలనుకుంటున్నారా?",
  deleteConfirm: "రీసైకిల్ బిన్‌కు తరలించాలా?", deleteFileConfirm: "ఈ ఫైల్ తొలగించాలా?",
  deleteTeamConfirm: "జట్టు తొలగించాలా? ఇది పూర్వపు స్థితికి తేలేరు.",
  permanentDeleteConfirm: "శాశ్వతంగా తొలగించాలా? ఇది పూర్వపు స్థితికి తేలేరు.",
  page: "పేజీ", of: "లో", prev: "← మునుపటి", nextPage: "తదుపరి →",
  loading: "లోడ్ అవుతోంది…", error: "లోపం", success: "విజయం",
  overdue: "గడువు దాటింది", dueToday: "నేడు గడువు!", dueIn: "లో గడువు",
  tut_step1_title: "మీ మొదటి ఫోల్డర్ సృష్టించండి",
  tut_step1_desc: "VaultSphere మీ పనిని ఫోల్డర్లలో నిర్వహిస్తుంది. ప్రతి ఫోల్డర్‌లో అనేక ఫైళ్లు ఉండవచ్చు.",
  tut_step1_tip: "💡 డాష్‌బోర్డ్‌లో ఎక్కడైనా N నొక్కండి",
  tut_step2_title: "ఫోల్డర్లలో ఫైళ్లు అప్‌లోడ్ చేయండి",
  tut_step2_desc: "ఏ ఫోల్డర్‌నైనా తెరవండి మరియు ఫైళ్లు డ్రాప్ చేయండి. PDF, కోడ్ ఫైళ్లు, చిత్రాలు — ఏ ఫైల్ రకమైనా 25MB వరకు.",
  tut_step2_tip: "💡 ఒకేసారి అనేక ఫైళ్లు అప్‌లోడ్ చేయండి",
  tut_step3_title: "AI ఫైల్ విశ్లేషణ",
  tut_step3_desc: "ఏ ఫైల్‌పైనైనా 🤖 AI బటన్ క్లిక్ చేయండి — సారాంశం, ముఖ్య అంశాలు, సంక్లిష్టత మరియు సూచించిన ట్యాగ్‌లు.",
  tut_step3_tip: "💡 కోడ్ ఫైళ్లు, PDF, టెక్స్ట్ ఫైళ్లపై పనిచేస్తుంది",
  tut_step4_title: "జట్టు సభ్యులతో సహకరించండి",
  tut_step4_desc: "సహకారం ట్యాబ్‌కు వెళ్ళి జట్టు సభ్యులను ఆహ్వానించండి. పాత్ర ఆధారంగా యాక్సెస్ ఇవ్వండి.",
  tut_step4_tip: "💡 స్వీకరించిన ఆహ్వానాలు 'నాతో భాగస్వామ్యం' ట్యాబ్‌లో కనిపిస్తాయి",
  tut_step5_title: "మీ సర్టిఫికెట్లు నిల్వ చేయండి",
  tut_step5_desc: "Coursera, NPTEL లేదా Google నుండి సర్టిఫికెట్ వచ్చిందా? సర్టిఫికెట్లు ట్యాబ్‌లో నిల్వ చేయండి!",
  tut_step5_tip: "💡 సర్టిఫికెట్లు స్వయంచాలకంగా ట్యాగ్ చేయబడతాయి",
  tut_step6_title: "మీ విశ్లేషణలను ట్రాక్ చేయండి",
  tut_step6_desc: "విశ్లేషణలు ట్యాబ్ GitHub-స్టైల్ హీట్‌మ్యాప్, నెలవారీ ఫైళ్లు మరియు బ్యాడ్జ్‌లు చూపుతుంది.",
  tut_step6_tip: "💡 VaultSphere వాడుతూ బ్యాడ్జ్‌లు సంపాదించండి",
  tut_skip: "దాటవేయి →", tut_next: "తదుపరి →", tut_back: "← వెనుక", tut_letsgo: "వెళ్ళండి! 🚀",
  tut_nudge_title: "చివరగా ఒక విషయం!", tut_nudge_desc1: "మీరు వేగంగా 2 నిమిషాల సర్వే నింపగలరా?",
  tut_nudge_desc2: "మీ అభిప్రాయం మా AI మోడల్‌ను శిక్షిస్తుంది 🤖",
  tut_fill_survey: "సర్వే నింపండి 🚀", tut_maybe_later: "తర్వాత →", tut_of: "లో",
  survey_q1: "మీరు ఎవరని చెప్పుకోగలరు?",
  survey_q1_o1: "విద్యార్థి", survey_q1_o2: "డెవలపర్", survey_q1_o3: "డిజైనర్",
  survey_q1_o4: "పరిశోధకుడు", survey_q1_o5: "ఉపాధ్యాయుడు / ప్రొఫెసర్", survey_q1_o6: "ఇతరులు",
  survey_q2: "మీరు ఏ సంవత్సరంలో ఉన్నారు?",
  survey_q2_o1: "మొదటి సంవత్సరం", survey_q2_o2: "రెండవ సంవత్సరం", survey_q2_o3: "మూడవ సంవత్సరం",
  survey_q2_o4: "నాల్గవ సంవత్సరం", survey_q2_o5: "పోస్ట్ గ్రాడ్యుయేట్", survey_q2_o6: "పని చేసే నిపుణుడు",
  survey_q3: "మీరు VaultSphere ను ప్రధానంగా దేనికి వాడతారు?",
  survey_q3_o1: "ప్రాజెక్ట్ ఫైళ్లు నిల్వ చేయడం", survey_q3_o2: "జట్టుతో సహకరించడం",
  survey_q3_o3: "అసైన్‌మెంట్లు నిర్వహించడం", survey_q3_o4: "సర్టిఫికెట్లు నిల్వ చేయడం", survey_q3_o5: "పైన అన్నీ",
  survey_q4: "మీకు ఏ ఫీచర్లు చాలా ఉపయోగకరంగా అనిపిస్తాయి?",
  survey_q4_o1: "AI ఫైల్ విశ్లేషణ", survey_q4_o2: "జట్టు సహకారం",
  survey_q4_o3: "విశ్లేషణలు డాష్‌బోర్డ్", survey_q4_o4: "వెర్షన్ చరిత్ర",
  survey_q4_o5: "సర్టిఫికెట్ నిల్వ", survey_q4_o6: "పబ్లిక్ షేర్ లింక్‌లు",
  survey_q5: "మీరు VaultSphere ని మొత్తంగా ఎలా రేట్ చేస్తారు?",
  survey_q6: "డిజైన్ మీకు ఎలా నచ్చింది?",
  survey_q6_o1: "చాలా నచ్చింది! 😍", survey_q6_o2: "బాగుంది 👍",
  survey_q6_o3: "మెరుగుపడవచ్చు 😐", survey_q6_o4: "మరింత పని అవసరం 🔧",
  survey_q7: "మీరు ఏం మెరుగుపరచాలని కోరుకుంటున్నారు?",
  survey_q7_o1: "వేగంగా పనిచేయడం", survey_q7_o2: "మరిన్ని AI ఫీచర్లు",
  survey_q7_o3: "మెరుగైన మొబైల్ అనుభవం", survey_q7_o4: "ఎక్కువ స్టోరేజ్",
  survey_q7_o5: "డార్క్ మోడ్", survey_q7_o6: "ఏమీ లేదు — చాలా బాగుంది!",
  survey_q8: "మీరు VaultSphere ను మీ స్నేహితుడికి సిఫారసు చేస్తారా?",
  survey_q8_o1: "తప్పకుండా అవును! 🚀", survey_q8_o2: "బహుశా అవును", survey_q8_o3: "నిశ్చయం లేదు", survey_q8_o4: "బహుశా కాదు",
  survey_q9: "ఇతర అభిప్రాయం లేదా సూచనలు?", survey_q9_placeholder: "మీరు ఏమనుకుంటున్నారో చెప్పండి… (ఐచ్ఛికం)",
  survey_select_all: "వర్తించే అన్నింటినీ ఎంచుకోండి",
  survey_skip: "సర్వే దాటవేయి →", survey_back: "← వెనుక", survey_next: "తదుపరి →",
  survey_submit: "సమర్పించండి 🚀", survey_submitting: "సమర్పిస్తోంది…",
  survey_done_title: "ధన్యవాదాలు!", survey_done_desc: "మీ అభిప్రాయం VaultSphere మెరుగుపరచడంలో సహాయపడుతుంది.",
  survey_done_btn: "డాష్‌బోర్డ్‌కు వెళ్ళండి 🚀", survey_of: "లో",
  sv_shared: "🔗 భాగస్వామ్య ప్రాజెక్ట్", sv_sharedBy: "భాగస్వామ్యం చేసిన వారు", sv_description: "వివరణ",
  sv_techStack: "టెక్ స్టాక్", sv_tags: "ట్యాగ్‌లు", sv_attachedFile: "జత చేసిన ఫైల్",
  sv_viewGithub: "🐙 GitHub లో చూడండి", sv_downloadFile: "↓ ఫైల్ డౌన్‌లోడ్ చేయండి",
  sv_notFound: "ప్రాజెక్ట్ కనుగొనబడలేదు లేదా భాగస్వామ్యం నిలిపివేయబడింది.",
  sv_loading: "లోడ్ అవుతోంది…", sv_watermark: "VaultSphere తో తయారు చేయబడింది",
  sv_goToVS: "← VaultSphere కు వెళ్ళండి",
  welcomeToVaultSphere: "VaultSphere కి స్వాగతం!",
  onboard1Desc: "మీ వ్యక్తిగత ప్రాజెక్ట్ వాల్ట్. మీ పనిని ఒకే చోట నిల్వ చేయండి.",
  createFirstProject: "మీ మొదటి ఫోల్డర్ సృష్టించండి",
  onboard2Desc: "'+ కొత్త ఫోల్డర్' బటన్ నొక్కండి లేదా ఎక్కడైనా N నొక్కండి.",
  collaborateWithTeammates: "జట్టు సభ్యులతో సహకరించండి",
  onboard3Desc: "వినియోగదారులను వెతకడానికి సహకారం ట్యాబ్‌కు వెళ్ళండి.",
  findAnythingInstantly: "తక్షణమే ఏదైనా కనుగొనండి",
  onboard4Desc: "గ్లోబల్ శోధన తెరవడానికి / నొక్కండి.",
  next: "తదుపరి →", back: "← వెనుక", letsGo: "వెళ్ళండి! 🚀", skipTour: "టూర్ దాటవేయండి",
};

const TA = {
  login: "உள்நுழைவு", email: "மின்னஞ்சல் முகவரி", password: "கடவுச்சொல்",
  loginButton: "உள்நுழைக", noAccount: "கணக்கு இல்லையா?", registerHere: "இங்கே பதிவு செய்யுங்கள்",
  loggingIn: "உள்நுழைகிறது...", signingIn: "உள்நுழைகிறது…", loginTagline: "பாதுகாப்பான · நேர்த்தியான · சக்திவாய்ந்த",
  forgotPasswordLink: "கடவுச்சொல் மறந்தீர்களா?",
  register: "பதிவு", fullName: "முழு பெயர்", createAccount: "கணக்கு உருவாக்கவும்",
  registerButton: "பதிவு செய்யுங்கள்", registering: "பதிவு செய்கிறது...", alreadyAccount: "ஏற்கனவே கணக்கு உள்ளதா?",
  loginHere: "இங்கே உள்நுழைக",
  passwordHint: "கடவுச்சொல்லில் இருக்க வேண்டும்: 8+ எழுத்துகள், பெரிய எழுத்துகள், சிறிய எழுத்துகள், எண் மற்றும் சிறப்பு எழுத்து (@$!%*?&)",
  reg_step1: "படி 1/2 — உங்கள் விவரங்கள்", reg_step2: "படி 2/2 — மொழி தேர்வு",
  reg_pickOnce: "ஒரு முறை தேர்வு செய்யுங்கள் — அமைப்புகளில் மாற்றலாம்.",
  reg_next: "அடுத்து →", reg_creating: "கணக்கு உருவாக்குகிறது…", reg_back: "← பின்",
  chooseLanguage: "உங்கள் விருப்பமான மொழியை தேர்ந்தெடுக்கவும்",
  verifyEmail: "மின்னஞ்சலை சரிபார்க்கவும்", enterOtp: "6 இலக்க OTP ஐ உள்ளிடவும்", verifyButton: "OTP சரிபார்க்கவும்",
  verifying: "சரிபார்க்கிறது...", resendOtp: "OTP மீண்டும் அனுப்பவும்", sending: "அனுப்புகிறது...",
  otpExpiry: "OTP 10 நிமிடங்களில் காலாவதியாகும்", otpSentTo: "OTP அனுப்பப்பட்டது",
  selectLanguage: "மொழியை தேர்ந்தெடுக்கவும்", continue: "தொடரவும்",
  forgotPassword: "கடவுச்சொல் மறந்தீர்களா?", resetPassword: "கடவுச்சொல்லை மீட்டமை", sendOtp: "OTP அனுப்பு",
  newPassword: "புதிய கடவுச்சொல்", confirmPassword: "கடவுச்சொல்லை உறுதிப்படுத்தவும்",
  fp_tagline: "கடவுச்சொல்லை மீட்டமை", fp_step1: "படி 1/2 — உங்கள் மின்னஞ்சலை உள்ளிடவும்",
  fp_emailPlaceholder: "உங்கள் பதிவு செய்த மின்னஞ்சல்", fp_sendingOtp: "OTP அனுப்புகிறது…",
  fp_sendResetOtp: "மீட்டமை OTP அனுப்பு", fp_step2: "படி 2/2 — OTP மற்றும் புதிய கடவுச்சொல்",
  fp_newPasswordPlaceholder: "புதிய கடவுச்சொல்", fp_confirmPasswordPlaceholder: "கடவுச்சொல்லை உறுதிப்படுத்தவும்",
  fp_resetting: "மீட்டமை செய்கிறது…", fp_resetPassword: "கடவுச்சொல்லை மீட்டமை",
  fp_rememberPassword: "கடவுச்சொல் நினைவிருக்கிறதா?", fp_loginHere: "இங்கே உள்நுழைக",
  english: "ஆங்கிலம்", hindi: "இந்தி", telugu: "தெலுங்கு", tamil: "தமிழ்", malayalam: "மலையாளம்",
  dashboard: "டாஷ்போர்டு", myFolders: "என் கோப்புறைகள்", sharedWithMe: "என்னுடன் பகிரப்பட்டது",
  newFolder: "+ புதிய கோப்புறை", searchFolders: "கோப்புறைகளை தேடுங்கள்...", noFoldersYet: "இன்னும் கோப்புறைகள் இல்லை",
  createFirstFolder: "தொடங்க உங்கள் முதல் கோப்புறையை உருவாக்கவும்.",
  createFirstFolderBtn: "+ முதல் கோப்புறை உருவாக்கவும்",
  totalFolders: "மொத்த கோப்புறைகள்", totalFiles: "மொத்த கோப்புகள்", daysActive: "செயலில் நாட்கள்", badgesEarned: "பேட்ஜ்கள் சம்பாதித்தது",
  folderName: "கோப்புறை பெயர் *", description: "விளக்கம்", tags: "குறிச்சொற்கள் (கமாவால் பிரிக்கவும்)",
  status: "நிலை", dueDate: "கடைசி தேதி", changeNote: "மாற்ற குறிப்பு (விருப்பத்தேர்வு)",
  addFiles: "கோப்புகளை சேர்க்கவும் (விருப்பத்தேர்வு)", dropFiles: "கிளிக் செய்யவும் அல்லது கோப்புகளை இழுக்கவும்",
  anyFileType: "எந்த கோப்பு வகையும் · அதிகபட்சம் 25MB",
  saveChanges: "மாற்றங்களை சேமிக்கவும்", cancel: "ரத்து செய்யவும்",
  createFolder: "📁 கோப்புறை உருவாக்கவும்", createFolderBtn: "📁 கோப்புறை உருவாக்கவும்",
  editFolder: "✏️ கோப்புறையை திருத்தவும்", deleteFolder: "🗑️ நீக்கு",
  share: "🔗 பகிர்", sharingOn: "🔗 பகிர்வு இயக்கம்",
  sharingDisabled: "பகிர்வு முடக்கப்பட்டது", sharingEnabled: "பகிர்வு இயக்கப்பட்டது — இணைப்பு உள்ள யாரும் பார்க்கலாம்",
  saving: "சேமிக்கிறது…",
  files: "கோப்புகள்", noFilesYet: "இன்னும் கோப்புகள் இல்லை — கீழே பதிவேற்றவும்",
  clickToView: "பார்க்க கிளிக் செய்யவும் · ↓ பதிவிறக்கவும்",
  dropFilesHere: "கோப்புகளை இங்கே இடுங்கள் அல்லது பதிவேற்ற கிளிக் செய்யவும்",
  view: "பார்", edit: "திருத்து", download: "↓", delete: "✕", aiAnalyse: "🤖 AI",
  uploadMoreFiles: "மேலும் கோப்புகளை பதிவேற்றவும்",
  details: "விவரங்கள்", comments: "கருத்துகள்", activity: "செயல்பாடு", history: "வரலாறு",
  active: "செயலில்", inProgress: "நடப்பில்", completed: "முடிந்தது", onHold: "நிறுத்தப்பட்டது", archived: "காப்பகப்படுத்தப்பட்டது",
  allStatuses: "அனைத்து நிலைகளும்",
  publicShareLink: "பொது பகிர்வு இணைப்பு", tags2: "குறிச்சொற்கள்",
  noCommentsYet: "இன்னும் கருத்துகள் இல்லை!", addComment: "கருத்து சேர்க்கவும்", post: "இடுக",
  noActivityYet: "இன்னும் செயல்பாடு இல்லை.", noVersionHistory: "இன்னும் பதிப்பு வரலாறு இல்லை.",
  historyAutoSaves: "திருத்தும்போது வரலாறு தானாக சேமிக்கப்படும்.",
  restore: "↩ மீட்டமை", savedVersions: "சேமிக்கப்பட்ட பதிப்புகள்", current: "தற்போதைய",
  restoreVersion: "இந்த பதிப்பிற்கு மீட்டமை செய்யவா?",
  recycleBin: "மறுசுழற்சி தொட்டி", restoreOrDelete: "மீட்டமை அல்லது நிரந்தரமாக நீக்கவும்",
  binIsEmpty: "மறுசுழற்சி தொட்டி காலியாக உள்ளது", deletedAppearHere: "நீக்கப்பட்ட திட்டங்கள் இங்கே தோன்றும்.",
  restoreProject: "↩ மீட்டமை", deleteForever: "✕ என்றும் நீக்கு",
  collaboration: "ஒத்துழைப்பு", inviteTeammates: "குழு உறுப்பினர்களை அழைக்கவும்",
  sendInvite: "✉️ அழைப்பிதழ் அனுப்பு", received: "📬 பெற்றது", sent: "📤 அனுப்பியது",
  findUsers: "🔍 பயனர்களை கண்டுபிடி", typeToSearch: "பயனர்களை தேட தட்டச்சு செய்யவும்",
  emailAddress: "மின்னஞ்சல் முகவரி *", project: "திட்டம்", role: "பாத்திரம்",
  viewer: "பார்வையாளர்", editor: "ஆசிரியர்", admin: "நிர்வாகி",
  sendInviteBtn: "அழைப்பிதழ் அனுப்பு", sending2: "அனுப்புகிறது…",
  noInvitationsReceived: "அழைப்பிதழ்கள் எதுவும் பெறவில்லை", noInvitesSent: "இன்னும் அழைப்பிதழ்கள் அனுப்பவில்லை",
  accept: "ஏற்கவும் ✅", decline: "மறுக்கவும் ❌", cancel2: "ரத்து",
  inviteAccepted: "ஏற்கப்பட்டது", inviteDeclined: "மறுக்கப்பட்டது", invitePending: "நிலுவையில்",
  analytics: "பகுப்பாய்வு", personalDashboard: "உங்கள் தனிப்பட்ட VaultSphere செயல்பாடு டாஷ்போர்டு",
  activityHeatmap: "செயல்பாடு வெப்பவரைபடம்", lastYear: "கடந்த ஆண்டில் கோப்புறை உருவாக்கம் + கோப்பு பதிவேற்றங்கள்",
  filesUploaded: "பதிவேற்றப்பட்ட கோப்புகள்", foldersCreated: "உருவாக்கப்பட்ட கோப்புறைகள்",
  last6Months: "கடந்த 6 மாதங்கள்", folderStatus: "கோப்புறை நிலை", breakdownByStatus: "நிலை வாரியாக",
  mostActiveFolders: "மிகவும் செயலில் உள்ள கோப்புறைகள்", byNumberOfFiles: "கோப்புகளின் எண்ணிக்கையால்",
  noFoldersYet2: "இன்னும் கோப்புறைகள் இல்லை", badgesEarned2: "சம்பாதித்த பேட்ஜ்கள் 🏆",
  badgesUnlocked: "6 இல் பேட்ஜ்கள் திறக்கப்பட்டன", refresh: "↻ புதுப்பி",
  teams: "குழுக்கள்", createTeams: "குழுக்களை உருவாக்கி உறுப்பினர்களை அழைக்கவும்",
  newTeam: "+ புதிய குழு", createNewTeam: "புதிய குழு உருவாக்கவும்",
  teamName: "குழு பெயர் எ.கா. டிசைன் ஸ்குவாட்…",
  createTeamBtn: "குழு உருவாக்கவும்", noTeamsYet: "இன்னும் குழுக்கள் இல்லை",
  createTeamSub: "பகிரப்பட்ட திட்டங்களில் ஒத்துழைக்க ஒரு குழு உருவாக்கவும்.",
  createFirstTeam: "+ முதல் குழு உருவாக்கவும்",
  members: "உறுப்பினர்கள்", inviteSomeone: "யாரையாவது அழைக்கவும்",
  enterEmail: "மின்னஞ்சல் முகவரியை உள்ளிடவும்…", addBtn: "+ சேர்", adding: "சேர்க்கிறது…",
  mustHaveAccount: "நபருக்கு ஏற்கனவே VaultSphere கணக்கு இருக்க வேண்டும்",
  deleteTeam: "🗑️ குழுவை நீக்கு", remove: "நீக்கு", owner: "👑 உரிமையாளர்", you: "நீங்கள்",
  certificates: "சான்றிதழ்கள்", certificatesSubtitle: "உங்கள் அனைத்து சான்றிதழ்களையும் ஒரே இடத்தில் வைக்கவும்",
  addCertificate: "+ சான்றிதழ் சேர்க்கவும்", addAnotherCertificate: "மற்றொரு சான்றிதழ் சேர்க்கவும்",
  addFirstCertificate: "+ முதல் சான்றிதழ் சேர்க்கவும்",
  noCertificatesYet: "இன்னும் சான்றிதழ்கள் இல்லை",
  noCertSub: "Coursera, NPTEL, Google, Udemy இலிருந்து சான்றிதழ்களை சேர்க்கவும்.",
  certName: "சான்றிதழ் பெயர் *", certNamePlaceholder: "எ.கா. AWS Cloud Practitioner…",
  certIssuer: "வழங்கியவர்", certIssuerPlaceholder: "எ.கா. Coursera, NPTEL, Google…",
  certDate: "வழங்கிய தேதி", certTags: "குறிச்சொற்கள் (கமாவால் பிரிக்கவும்)",
  certFile: "சான்றிதழ் கோப்பை பதிவேற்றவும் (PDF/Image)",
  certAdding: "சேர்க்கிறது…", certAddBtn: "🏆 சான்றிதழ் சேர்க்கவும்",
  totalCertificates: "மொத்த சான்றிதழ்கள்", filesStored: "சேமிக்கப்பட்ட கோப்புகள்", skillsTagged: "குறிச்சொல்லிட்ட திறன்கள்",
  issuedBy: "வழங்கியவர்:",
  survey: "கணக்கெடுப்பு", shareFeedback: "உங்கள் கருத்தை பகிர்ந்துகொள்ளுங்கள்",
  surveyBannerTitle: "VaultSphere ஐ மேம்படுத்த உதவுங்கள்!",
  surveyBannerSub: "வெறும் 2 நிமிடங்கள் · உங்கள் கருத்து AI மாதிரியை பயிற்றுவிக்கிறது 🤖",
  takeSurvey: "கணக்கெடுப்பு எடுங்கள் →", surveyAlreadyDone: "✅ நீங்கள் ஏற்கனவே கணக்கெடுப்பை முடித்தீர்கள் — நன்றி!",
  startSurvey: "கணக்கெடுப்பை தொடங்கவும் →", helpUsImprove: "VaultSphere ஐ மேம்படுத்த உதவுங்கள்",
  surveyDesc: "2 நிமிடங்களில் உங்கள் கருத்தை பகிர்ந்துகொள்ளுங்கள்.",
  settings: "அமைப்புகள்", language: "மொழி", changeLanguage: "மொழியை மாற்றவும்",
  currentLanguage: "தற்போதைய மொழி", signOut: "வெளியேறு",
  signOutDesc: "நீங்கள் வெளியேற்றப்பட்டு உள்நுழைவு பக்கத்திற்கு திரும்பப்படுவீர்கள்.", signOutBtn: "வெளியேறு",
  managePreferences: "உங்கள் விருப்பத்தேர்வுகளை நிர்வகிக்கவும்",
  changeLangDesc: "மொழியை மாற்றவும் — உடனடியாக எங்கும் பொருந்துகிறது",
  accountSettings: "கணக்கு", accountDesc: "உங்கள் பெயர் அல்லது கடவுச்சொல்லை சுயவிவர பக்கத்திலிருந்து புதுப்பிக்கவும்.",
  openProfile: "சுயவிவரம் திறக்கவும் →", tutorialSettings: "பயிற்சி",
  tutorialDesc: "VaultSphere அம்சங்களை கற்க பயிற்சியை மீண்டும் பார்க்கவும்.",
  viewTutorial: "பயிற்சி பார்க்கவும் →",
  profile: "சுயவிவரம்",
  notifications: "அறிவிப்புகள்", allCaughtUp: "எல்லாம் சரி! அறிவிப்புகள் இல்லை.",
  markAllRead: "அனைத்தையும் படித்ததாக குறி", clearAll: "அனைத்தையும் அழி",
  searchPlaceholder: "திட்டங்கள், குறிச்சொற்கள் தேடவும்…",
  recentProjects: "சமீபத்திய திட்டங்கள்", noTechStack: "தொழில்நுட்ப அடுக்கு இல்லை", noTags: "குறிச்சொற்கள் இல்லை",
  results: "முடிவுகள்", navigate: "செல்லுங்கள்", open: "திறக்கவும்", close: "மூடு",
  searchNoResults: "க்கு முடிவுகள் இல்லை",
  pinFolder: "📌 இணைக்கவும்", unpinFolder: "நீக்கவும்", pinnedFolders: "இணைக்கப்பட்ட கோப்புறைகள்",
  noPinnedFolders: "இன்னும் இணைக்கப்பட்ட கோப்புறைகள் இல்லை", pinHint: "விரைவான அணுகலுக்கு 3 கோப்புறைகள் வரை இணைக்கவும்",
  editorSaving: "சேமிக்கிறது…", editorSave: "💾 சேமி",
  loadingFile: "கோப்பு உள்ளடக்கம் ஏற்றுகிறது…", tabHint: "Tab = 2 இடைவெளிகள் · Ctrl+S சேமிக்கிறது",
  fileAppearEmpty: "கோப்பு காலியாக தெரிகிறது", tryReupload: "கோப்பை மீண்டும் பதிவேற்ற முயற்சிக்கவும்",
  analysingFile: "AI உடன் கோப்பை பகுப்பாய்வு செய்கிறது…", aiMayTake: "இது சில நிமிடங்கள் ஆகலாம்",
  aiSummary: "📋 சுருக்கம்", aiKeyPoints: "🔑 முக்கிய புள்ளிகள்", aiComplexity: "⚡ சிக்கலான தன்மை",
  aiSuggestions: "💡 பரிந்துரைகள்", aiTags: "🏷️ பரிந்துரைக்கப்பட்ட குறிச்சொற்கள்",
  logout: "வெளியேறு", logoutConfirm: "நீங்கள் வெளியேற விரும்புகிறீர்களா?",
  deleteConfirm: "மறுசுழற்சி தொட்டிக்கு நகர்த்தவும்?", deleteFileConfirm: "இந்த கோப்பை நீக்கவா?",
  deleteTeamConfirm: "குழுவை நீக்கவா? இதை செயல்தவிர்க்க முடியாது.",
  permanentDeleteConfirm: "நிரந்தரமாக நீக்கவா? செயல்தவிர்க்க முடியாது.",
  page: "பக்கம்", of: "இல்", prev: "← முந்தைய", nextPage: "அடுத்து →",
  loading: "ஏற்றுகிறது…", error: "பிழை", success: "வெற்றி",
  overdue: "காலாவதியானது", dueToday: "இன்று கடைசி!", dueIn: "இல் கடைசி",
  tut_step1_title: "உங்கள் முதல் கோப்புறையை உருவாக்கவும்",
  tut_step1_desc: "VaultSphere உங்கள் வேலையை கோப்புறைகளில் ஒழுங்கமைக்கிறது. ஒவ்வொரு கோப்புறையிலும் பல கோப்புகள் இருக்கலாம்.",
  tut_step1_tip: "💡 டாஷ்போர்டில் எங்கும் N அழுத்தவும்",
  tut_step2_title: "கோப்புறைகளில் கோப்புகளை பதிவேற்றவும்",
  tut_step2_desc: "எந்த கோப்புறையையும் திறந்து கோப்புகளை இடுங்கள். PDF, குறியீட்டு கோப்புகள், படங்கள் — எந்த கோப்பு வகையும் 25MB வரை.",
  tut_step2_tip: "💡 ஒரே நேரத்தில் பல கோப்புகளை பதிவேற்றவும்",
  tut_step3_title: "AI கோப்பு பகுப்பாய்வு",
  tut_step3_desc: "எந்த கோப்பிலும் 🤖 AI பொத்தானை கிளிக் செய்யுங்கள் — சுருக்கம், முக்கிய புள்ளிகள், சிக்கலான தன்மை மற்றும் குறிச்சொற்கள்.",
  tut_step3_tip: "💡 குறியீட்டு கோப்புகள், PDF, உரை கோப்புகளில் செயல்படுகிறது",
  tut_step4_title: "குழு உறுப்பினர்களுடன் ஒத்துழைக்கவும்",
  tut_step4_desc: "ஒத்துழைப்பு தாவலுக்கு சென்று குழு உறுப்பினர்களை அழைக்கவும். பாத்திரத்தின் அடிப்படையில் அணுகலை வழங்கவும்.",
  tut_step4_tip: "💡 ஏற்றுக்கொள்ளப்பட்ட அழைப்புகள் 'என்னுடன் பகிரப்பட்டது' தாவலில் தோன்றும்",
  tut_step5_title: "உங்கள் சான்றிதழ்களை சேமிக்கவும்",
  tut_step5_desc: "Coursera, NPTEL அல்லது Google இலிருந்து சான்றிதழ் வந்ததா? சான்றிதழ்கள் தாவலில் சேமிக்கவும்!",
  tut_step5_tip: "💡 சான்றிதழ்கள் தானாகவே குறிச்சொல்லிடப்பட்டு தேடக்கூடியவை",
  tut_step6_title: "உங்கள் பகுப்பாய்வை கண்காணிக்கவும்",
  tut_step6_desc: "பகுப்பாய்வு தாவல் GitHub-பாணி வெப்பவரைபடம், மாதாந்திர கோப்புகள் மற்றும் பேட்ஜ்கள் காட்டுகிறது.",
  tut_step6_tip: "💡 VaultSphere பயன்படுத்தி பேட்ஜ்கள் சம்பாதிக்கவும்",
  tut_skip: "தவிர்க்கவும் →", tut_next: "அடுத்து →", tut_back: "← பின்", tut_letsgo: "போகலாம்! 🚀",
  tut_nudge_title: "கடைசியாக ஒன்று!", tut_nudge_desc1: "விரைவான 2 நிமிட கணக்கெடுப்பை நிரப்ப முடியுமா?",
  tut_nudge_desc2: "உங்கள் கருத்து எங்கள் AI மாதிரியை பயிற்றுவிக்கிறது 🤖",
  tut_fill_survey: "கணக்கெடுப்பை நிரப்பவும் 🚀", tut_maybe_later: "பின்னர் →", tut_of: "இல்",
  survey_q1: "நீங்கள் யார் என்று சொல்வீர்கள்?",
  survey_q1_o1: "மாணவர்", survey_q1_o2: "டெவலப்பர்", survey_q1_o3: "டிசைனர்",
  survey_q1_o4: "ஆராய்ச்சியாளர்", survey_q1_o5: "ஆசிரியர் / பேராசிரியர்", survey_q1_o6: "மற்றவர்",
  survey_q2: "நீங்கள் எந்த ஆண்டில் படிக்கிறீர்கள்?",
  survey_q2_o1: "1ஆம் ஆண்டு", survey_q2_o2: "2ஆம் ஆண்டு", survey_q2_o3: "3ஆம் ஆண்டு",
  survey_q2_o4: "4ஆம் ஆண்டு", survey_q2_o5: "முதுகலை", survey_q2_o6: "பணிபுரியும் நிபுணர்",
  survey_q3: "VaultSphere ஐ முக்கியமாக எதற்காக பயன்படுத்துவீர்கள்?",
  survey_q3_o1: "திட்டக் கோப்புகளை சேமிக்க", survey_q3_o2: "குழுவுடன் ஒத்துழைக்க",
  survey_q3_o3: "பணிகளை ஒழுங்கமைக்க", survey_q3_o4: "சான்றிதழ்களை சேமிக்க", survey_q3_o5: "மேலே உள்ள அனைத்தும்",
  survey_q4: "எந்த அம்சங்கள் மிகவும் பயனுள்ளதாக இருக்கும்?",
  survey_q4_o1: "AI கோப்பு பகுப்பாய்வு", survey_q4_o2: "குழு ஒத்துழைப்பு",
  survey_q4_o3: "பகுப்பாய்வு டாஷ்போர்டு", survey_q4_o4: "பதிப்பு வரலாறு",
  survey_q4_o5: "சான்றிதழ் சேமிப்பு", survey_q4_o6: "பொது பகிர்வு இணைப்புகள்",
  survey_q5: "VaultSphere ஐ ஒட்டுமொத்தமாக எப்படி மதிப்பிடுவீர்கள்?",
  survey_q6: "வடிவமைப்பு எப்படி பிடித்திருக்கிறது?",
  survey_q6_o1: "மிகவும் பிடிக்கிறது! 😍", survey_q6_o2: "நன்றாக இருக்கிறது 👍",
  survey_q6_o3: "மேம்படலாம் 😐", survey_q6_o4: "மேலும் வேலை தேவை 🔧",
  survey_q7: "என்னை மேம்படுத்த விரும்புவீர்கள்?",
  survey_q7_o1: "வேகமான செயல்திறன்", survey_q7_o2: "மேலும் AI அம்சங்கள்",
  survey_q7_o3: "சிறந்த மொபைல் அனுபவம்", survey_q7_o4: "அதிக சேமிப்பு இடம்",
  survey_q7_o5: "டார்க் மோட்", survey_q7_o6: "ஏதும் இல்லை — சிறப்பாக உள்ளது!",
  survey_q8: "VaultSphere ஐ நண்பருக்கு பரிந்துரைப்பீர்களா?",
  survey_q8_o1: "நிச்சயமாக ஆம்! 🚀", survey_q8_o2: "ஒருவேளை ஆம்", survey_q8_o3: "நிச்சயமில்லை", survey_q8_o4: "ஒருவேளை இல்லை",
  survey_q9: "வேறு ஏதேனும் கருத்து அல்லது பரிந்துரைகள்?", survey_q9_placeholder: "நீங்கள் என்ன நினைக்கிறீர்கள் என்று சொல்லுங்கள்… (விருப்பத்தேர்வு)",
  survey_select_all: "பொருந்தும் அனைத்தையும் தேர்ந்தெடுக்கவும்",
  survey_skip: "கணக்கெடுப்பை தவிர்க்கவும் →", survey_back: "← பின்", survey_next: "அடுத்து →",
  survey_submit: "சமர்ப்பிக்கவும் 🚀", survey_submitting: "சமர்ப்பிக்கிறது…",
  survey_done_title: "நன்றி!", survey_done_desc: "உங்கள் கருத்து VaultSphere ஐ மேம்படுத்த உதவுகிறது.",
  survey_done_btn: "டாஷ்போர்டுக்கு செல்லவும் 🚀", survey_of: "இல்",
  sv_shared: "🔗 பகிரப்பட்ட திட்டம்", sv_sharedBy: "பகிர்ந்தவர்", sv_description: "விளக்கம்",
  sv_techStack: "தொழில்நுட்ப அடுக்கு", sv_tags: "குறிச்சொற்கள்", sv_attachedFile: "இணைக்கப்பட்ட கோப்பு",
  sv_viewGithub: "🐙 GitHub இல் பார்க்கவும்", sv_downloadFile: "↓ கோப்பை பதிவிறக்கவும்",
  sv_notFound: "திட்டம் கிடைக்கவில்லை அல்லது பகிர்வு முடக்கப்பட்டுள்ளது.",
  sv_loading: "ஏற்றுகிறது…", sv_watermark: "VaultSphere உடன் உருவாக்கப்பட்டது",
  sv_goToVS: "← VaultSphere க்கு செல்லவும்",
  welcomeToVaultSphere: "VaultSphere க்கு வரவேற்கிறோம்!",
  onboard1Desc: "உங்கள் தனிப்பட்ட திட்ட வால்ட். உங்கள் வேலையை ஒரே இடத்தில் சேமிக்கவும்.",
  createFirstProject: "உங்கள் முதல் கோப்புறையை உருவாக்கவும்",
  onboard2Desc: "'+ புதிய கோப்புறை' பொத்தானை அழுத்தவும்.",
  collaborateWithTeammates: "குழு உறுப்பினர்களுடன் ஒத்துழைக்கவும்",
  onboard3Desc: "பயனர்களை தேட ஒத்துழைப்பு தாவலுக்கு செல்லவும்.",
  findAnythingInstantly: "உடனடியாக எதையும் கண்டுபிடிக்கவும்",
  onboard4Desc: "உலகளாவிய தேடலை திறக்க / அழுத்தவும்.",
  next: "அடுத்து →", back: "← பின்", letsGo: "போகலாம்! 🚀", skipTour: "சுற்றுப்பயணத்தை தவிர்க்கவும்",
};

const ML = {
  login: "ലോഗിൻ", email: "ഇമെയിൽ വിലാസം", password: "പാസ്‌വേഡ്",
  loginButton: "ലോഗിൻ ചെയ്യുക", noAccount: "അക്കൗണ്ട് ഇല്ലേ?", registerHere: "ഇവിടെ രജിസ്റ്റർ ചെയ്യുക",
  loggingIn: "ലോഗിൻ ആകുന്നു...", signingIn: "സൈൻ ഇൻ ആകുന്നു…", loginTagline: "സുരക്ഷിതം · മനോഹരം · ശക്തിശാലി",
  forgotPasswordLink: "പാസ്‌വേഡ് മറന്നോ?",
  register: "രജിസ്റ്റർ", fullName: "പൂർണ്ണ നാമം", createAccount: "അക്കൗണ്ട് സൃഷ്ടിക്കുക",
  registerButton: "രജിസ്റ്റർ ചെയ്യുക", registering: "രജിസ്റ്റർ ആകുന്നു...", alreadyAccount: "ഇതിനകം അക്കൗണ്ട് ഉണ്ടോ?",
  loginHere: "ഇവിടെ ലോഗിൻ ചെയ്യുക",
  passwordHint: "പാസ്‌വേഡിൽ ഉണ്ടായിരിക്കണം: 8+ അക്ഷരങ്ങൾ, വലിയ അക്ഷരങ്ങൾ, ചെറിയ അക്ഷരങ്ങൾ, സംഖ്യ, പ്രത്യേക അക്ഷരം (@$!%*?&)",
  reg_step1: "ഘട്ടം 1/2 — നിങ്ങളുടെ വിവരങ്ങൾ", reg_step2: "ഘട്ടം 2/2 — ഭാഷ തിരഞ്ഞെടുക്കുക",
  reg_pickOnce: "ഒരു തവണ തിരഞ്ഞെടുക്കുക — സെറ്റിംഗ്സിൽ നിന്ന് മാറ്റാം.",
  reg_next: "അടുത്തത് →", reg_creating: "അക്കൗണ്ട് സൃഷ്ടിക്കുന്നു…", reg_back: "← തിരികെ",
  chooseLanguage: "നിങ്ങളുടെ ഇഷ്ടമുള്ള ഭാഷ തിരഞ്ഞെടുക്കുക",
  verifyEmail: "ഇമെയിൽ സ്ഥിരീകരിക്കുക", enterOtp: "6 അക്ക OTP നൽകുക", verifyButton: "OTP സ്ഥിരീകരിക്കുക",
  verifying: "സ്ഥിരീകരിക്കുന്നു...", resendOtp: "OTP വീണ്ടും അയക്കുക", sending: "അയക്കുന്നു...",
  otpExpiry: "OTP 10 മിനിറ്റിൽ കാലഹരണപ്പെടും", otpSentTo: "OTP അയച്ചു",
  selectLanguage: "ഭാഷ തിരഞ്ഞെടുക്കുക", continue: "തുടരുക",
  forgotPassword: "പാസ്‌വേഡ് മറന്നോ?", resetPassword: "പാസ്‌വേഡ് പുനഃസ്ഥാപിക്കുക", sendOtp: "OTP അയക്കുക",
  newPassword: "പുതിയ പാസ്‌വേഡ്", confirmPassword: "പാസ്‌വേഡ് സ്ഥിരീകരിക്കുക",
  fp_tagline: "പാസ്‌വേഡ് പുനഃസ്ഥാപിക്കുക", fp_step1: "ഘട്ടം 1/2 — നിങ്ങളുടെ ഇമെയിൽ നൽകുക",
  fp_emailPlaceholder: "നിങ്ങളുടെ രജിസ്റ്റർ ചെയ്ത ഇമെയിൽ", fp_sendingOtp: "OTP അയക്കുന്നു…",
  fp_sendResetOtp: "റീസെറ്റ് OTP അയക്കുക", fp_step2: "ഘട്ടം 2/2 — OTP, പുതിയ പാസ്‌വേഡ് നൽകുക",
  fp_newPasswordPlaceholder: "പുതിയ പാസ്‌വേഡ്", fp_confirmPasswordPlaceholder: "പാസ്‌വേഡ് സ്ഥിരീകരിക്കുക",
  fp_resetting: "പുനഃസ്ഥാപിക്കുന്നു…", fp_resetPassword: "പാസ്‌വേഡ് പുനഃസ്ഥാപിക്കുക",
  fp_rememberPassword: "പാസ്‌വേഡ് ഓർക്കുന്നുണ്ടോ?", fp_loginHere: "ഇവിടെ ലോഗിൻ ചെയ്യുക",
  english: "ഇംഗ്ലീഷ്", hindi: "ഹിന്ദി", telugu: "തെലുങ്ക്", tamil: "തമിഴ്", malayalam: "മലയാളം",
  dashboard: "ഡാഷ്‌ബോർഡ്", myFolders: "എന്റെ ഫോൾഡറുകൾ", sharedWithMe: "എന്നോട് പങ്കിട്ടത്",
  newFolder: "+ പുതിയ ഫോൾഡർ", searchFolders: "ഫോൾഡറുകൾ തിരയുക...", noFoldersYet: "ഇതുവരെ ഫോൾഡറുകൾ ഇല്ല",
  createFirstFolder: "ആരംഭിക്കാൻ നിങ്ങളുടെ ആദ്യ ഫോൾഡർ സൃഷ്ടിക്കുക.",
  createFirstFolderBtn: "+ ആദ്യ ഫോൾഡർ സൃഷ്ടിക്കുക",
  totalFolders: "മൊത്തം ഫോൾഡറുകൾ", totalFiles: "മൊത്തം ഫയലുകൾ", daysActive: "സജീവ ദിവസങ്ങൾ", badgesEarned: "ബാഡ്ജുകൾ നേടി",
  folderName: "ഫോൾഡർ പേര് *", description: "വിവരണം", tags: "ടാഗുകൾ (കോമ കൊണ്ട് വേർതിരിക്കുക)",
  status: "നില", dueDate: "കാലഹരണ തീയതി", changeNote: "മാറ്റ കുറിപ്പ് (ഐച്ഛികം)",
  addFiles: "ഫയലുകൾ ചേർക്കുക (ഐച്ഛികം)", dropFiles: "ക്ലിക്ക് ചെയ്യുക അല്ലെങ്കിൽ ഫയലുകൾ വലിച്ചിടുക",
  anyFileType: "ഏത് ഫയൽ തരവും · പരമാവധി 25MB",
  saveChanges: "മാറ്റങ്ങൾ സേവ് ചെയ്യുക", cancel: "റദ്ദാക്കുക",
  createFolder: "📁 ഫോൾഡർ സൃഷ്ടിക്കുക", createFolderBtn: "📁 ഫോൾഡർ സൃഷ്ടിക്കുക",
  editFolder: "✏️ ഫോൾഡർ എഡിറ്റ് ചെയ്യുക", deleteFolder: "🗑️ ഇല്ലാതാക്കുക",
  share: "🔗 പങ്കിടുക", sharingOn: "🔗 പങ്കിടൽ ഓൺ",
  sharingDisabled: "പങ്കിടൽ പ്രവർത്തനരഹിതമാക്കി", sharingEnabled: "പങ്കിടൽ പ്രവർത്തനക്ഷമം — ലിങ്ക് ഉള്ള ആർക്കും കാണാം",
  saving: "സേവ് ചെയ്യുന്നു…",
  files: "ഫയലുകൾ", noFilesYet: "ഇതുവരെ ഫയലുകൾ ഇല്ല — താഴെ അപ്‌ലോഡ് ചെയ്യുക",
  clickToView: "കാണാൻ ക്ലിക്ക് ചെയ്യുക · ↓ ഡൗൺലോഡ്",
  dropFilesHere: "ഫയലുകൾ ഇവിടെ ഇടുക അല്ലെങ്കിൽ അപ്‌ലോഡ് ചെയ്യാൻ ക്ലിക്ക് ചെയ്യുക",
  view: "കാണുക", edit: "എഡിറ്റ്", download: "↓", delete: "✕", aiAnalyse: "🤖 AI",
  uploadMoreFiles: "കൂടുതൽ ഫയലുകൾ അപ്‌ലോഡ് ചെയ്യുക",
  details: "വിശദാംശങ്ങൾ", comments: "അഭിപ്രായങ്ങൾ", activity: "പ്രവർത്തനം", history: "ചരിത്രം",
  active: "സജീവം", inProgress: "പുരോഗതിയിൽ", completed: "പൂർത്തിയായി", onHold: "നിർത്തിവച്ചത്", archived: "ആർക്കൈവ് ചെയ്തത്",
  allStatuses: "എല്ലാ നിലകളും",
  publicShareLink: "പൊതു ഷെയർ ലിങ്ക്", tags2: "ടാഗുകൾ",
  noCommentsYet: "ഇതുവരെ അഭിപ്രായങ്ങൾ ഇല്ല!", addComment: "അഭിപ്രായം ചേർക്കുക", post: "പോസ്റ്റ്",
  noActivityYet: "ഇതുവരെ പ്രവർത്തനം ഇല്ല.", noVersionHistory: "ഇതുവരെ പതിപ്പ് ചരിത്രം ഇല്ല.",
  historyAutoSaves: "എഡിറ്റ് ചെയ്യുമ്പോൾ ചരിത്രം സ്വയം സേവ് ആകും.",
  restore: "↩ പുനഃസ്ഥാപിക്കുക", savedVersions: "സേവ് ചെയ്ത പതിപ്പുകൾ", current: "നിലവിലുള്ളത്",
  restoreVersion: "ഈ പതിപ്പിലേക്ക് പുനഃസ്ഥാപിക്കണോ?",
  recycleBin: "റീസൈക്കിൾ ബിൻ", restoreOrDelete: "പുനഃസ്ഥാപിക്കുക അല്ലെങ്കിൽ സ്ഥിരമായി ഇല്ലാതാക്കുക",
  binIsEmpty: "റീസൈക്കിൾ ബിൻ ശൂന്യമാണ്", deletedAppearHere: "ഇല്ലാതാക്കിയ പ്രോജക്ടുകൾ ഇവിടെ കാണിക്കും.",
  restoreProject: "↩ പുനഃസ്ഥാപിക്കുക", deleteForever: "✕ എന്നേക്കും ഇല്ലാതാക്കുക",
  collaboration: "സഹകരണം", inviteTeammates: "ടീം അംഗങ്ങളെ ക്ഷണിക്കുക",
  sendInvite: "✉️ ക്ഷണം അയക്കുക", received: "📬 ലഭിച്ചത്", sent: "📤 അയച്ചത്",
  findUsers: "🔍 ഉപയോക്താക്കളെ കണ്ടെത്തുക", typeToSearch: "ഉപയോക്താക്കളെ തിരയാൻ ടൈപ്പ് ചെയ്യുക",
  emailAddress: "ഇമെയിൽ വിലാസം *", project: "പ്രോജക്ട്", role: "റോൾ",
  viewer: "കാഴ്ചക്കാരൻ", editor: "എഡിറ്റർ", admin: "അഡ്മിൻ",
  sendInviteBtn: "ക്ഷണം അയക്കുക", sending2: "അയക്കുന്നു…",
  noInvitationsReceived: "ക്ഷണങ്ങൾ ഒന്നും ലഭിച്ചിട്ടില്ല", noInvitesSent: "ഇതുവരെ ക്ഷണങ്ങൾ അയച്ചിട്ടില്ല",
  accept: "സ്വീകരിക്കുക ✅", decline: "നിരസിക്കുക ❌", cancel2: "റദ്ദാക്കുക",
  inviteAccepted: "സ്വീകരിച്ചു", inviteDeclined: "നിരസിച്ചു", invitePending: "തീർപ്പാകാത്തത്",
  analytics: "വിശകലനം", personalDashboard: "നിങ്ങളുടെ വ്യക്തിഗത VaultSphere പ്രവർത്തന ഡാഷ്‌ബോർഡ്",
  activityHeatmap: "പ്രവർത്തന ഹീറ്റ്‌മാപ്പ്", lastYear: "കഴിഞ്ഞ വർഷം ഫോൾഡർ സൃഷ്ടി + ഫയൽ അപ്‌ലോഡുകൾ",
  filesUploaded: "അപ്‌ലോഡ് ചെയ്ത ഫയലുകൾ", foldersCreated: "സൃഷ്ടിച്ച ഫോൾഡറുകൾ",
  last6Months: "കഴിഞ്ഞ 6 മാസം", folderStatus: "ഫോൾഡർ നില", breakdownByStatus: "നിലയനുസരിച്ച്",
  mostActiveFolders: "ഏറ്റവും സജീവമായ ഫോൾഡറുകൾ", byNumberOfFiles: "ഫയലുകളുടെ എണ്ണം അനുസരിച്ച്",
  noFoldersYet2: "ഇതുവരെ ഫോൾഡറുകൾ ഇല്ല", badgesEarned2: "നേടിയ ബാഡ്ജുകൾ 🏆",
  badgesUnlocked: "6 ൽ നിന്ന് ബാഡ്ജുകൾ അൺലോക്ക്", refresh: "↻ പുതുക്കുക",
  teams: "ടീമുകൾ", createTeams: "ടീമുകൾ സൃഷ്ടിക്കുക, അംഗങ്ങളെ ക്ഷണിക്കുക",
  newTeam: "+ പുതിയ ടീം", createNewTeam: "പുതിയ ടീം സൃഷ്ടിക്കുക",
  teamName: "ടീം പേര് ഉദാ. ഡിസൈൻ സ്ക്വാഡ്…",
  createTeamBtn: "ടീം സൃഷ്ടിക്കുക", noTeamsYet: "ഇതുവരെ ടീമുകൾ ഇല്ല",
  createTeamSub: "പങ്കിട്ട പ്രോജക്ടുകളിൽ സഹകരിക്കാൻ ഒരു ടീം സൃഷ്ടിക്കുക.",
  createFirstTeam: "+ ആദ്യ ടീം സൃഷ്ടിക്കുക",
  members: "അംഗങ്ങൾ", inviteSomeone: "ആരെയെങ്കിലും ക്ഷണിക്കുക",
  enterEmail: "ഇമെയിൽ വിലാസം നൽകുക…", addBtn: "+ ചേർക്കുക", adding: "ചേർക്കുന്നു…",
  mustHaveAccount: "വ്യക്തിക്ക് ഒരു VaultSphere അക്കൗണ്ട് ഉണ്ടായിരിക്കണം",
  deleteTeam: "🗑️ ടീം ഇല്ലാതാക്കുക", remove: "നീക്കുക", owner: "👑 ഉടമ", you: "നിങ്ങൾ",
  certificates: "സർട്ടിഫിക്കറ്റുകൾ", certificatesSubtitle: "നിങ്ങളുടെ എല്ലാ സർട്ടിഫിക്കറ്റുകളും ഒരിടത്ത് സൂക്ഷിക്കുക",
  addCertificate: "+ സർട്ടിഫിക്കറ്റ് ചേർക്കുക", addAnotherCertificate: "മറ്റൊരു സർട്ടിഫിക്കറ്റ് ചേർക്കുക",
  addFirstCertificate: "+ ആദ്യ സർട്ടിഫിക്കറ്റ് ചേർക്കുക",
  noCertificatesYet: "ഇതുവരെ സർട്ടിഫിക്കറ്റുകൾ ഇല്ല",
  noCertSub: "Coursera, NPTEL, Google, Udemy നിന്ന് സർട്ടിഫിക്കറ്റുകൾ ചേർക്കുക.",
  certName: "സർട്ടിഫിക്കറ്റ് പേര് *", certNamePlaceholder: "ഉദാ. AWS Cloud Practitioner…",
  certIssuer: "നൽകിയവർ", certIssuerPlaceholder: "ഉദാ. Coursera, NPTEL, Google…",
  certDate: "നൽകിയ തീയതി", certTags: "ടാഗുകൾ (കോമ കൊണ്ട് വേർതിരിക്കുക)",
  certFile: "സർട്ടിഫിക്കറ്റ് ഫയൽ അപ്‌ലോഡ് ചെയ്യുക (PDF/Image)",
  certAdding: "ചേർക്കുന്നു…", certAddBtn: "🏆 സർട്ടിഫിക്കറ്റ് ചേർക്കുക",
  totalCertificates: "മൊത്തം സർട്ടിഫിക്കറ്റുകൾ", filesStored: "സൂക്ഷിച്ച ഫയലുകൾ", skillsTagged: "ടാഗ് ചെയ്ത കഴിവുകൾ",
  issuedBy: "നൽകിയവർ:",
  survey: "സർവേ", shareFeedback: "നിങ്ങളുടെ അഭിപ്രായം പങ്കിടുക",
  surveyBannerTitle: "VaultSphere മെച്ചപ്പെടുത്താൻ സഹായിക്കൂ!",
  surveyBannerSub: "വെറും 2 മിനിറ്റ് · നിങ്ങളുടെ അഭിപ്രായം AI മോഡൽ പരിശീലിപ്പിക്കുന്നു 🤖",
  takeSurvey: "സർവേ ചെയ്യുക →", surveyAlreadyDone: "✅ നിങ്ങൾ ഇതിനകം സർവേ പൂർത്തിയാക്കി — നന്ദി!",
  startSurvey: "സർവേ ആരംഭിക്കുക →", helpUsImprove: "VaultSphere മെച്ചപ്പെടുത്താൻ സഹായിക്കൂ",
  surveyDesc: "2 മിനിറ്റ് കൊണ്ട് നിങ്ങളുടെ അഭിപ്രായം പങ്കിടുക.",
  settings: "ക്രമീകരണങ്ങൾ", language: "ഭാഷ", changeLanguage: "ഭാഷ മാറ്റുക",
  currentLanguage: "നിലവിലെ ഭാഷ", signOut: "സൈൻ ഔട്ട്",
  signOutDesc: "നിങ്ങൾ സൈൻ ഔട്ട് ചെയ്യപ്പെടും.", signOutBtn: "സൈൻ ഔട്ട്",
  managePreferences: "നിങ്ങളുടെ മുൻഗണനകൾ നിർവ്വഹിക്കുക",
  changeLangDesc: "ഭാഷ മാറ്റുക — ഉടനടി എല്ലായിടത്തും ബാധകമാകുന്നു",
  accountSettings: "അക്കൗണ്ട്", accountDesc: "നിങ്ങളുടെ പേര് അല്ലെങ്കിൽ പാസ്‌വേഡ് പ്രൊഫൈൽ പേജിൽ നിന്ന് അപ്‌ഡേറ്റ് ചെയ്യുക.",
  openProfile: "പ്രൊഫൈൽ തുറക്കുക →", tutorialSettings: "ട്യൂട്ടോറിയൽ",
  tutorialDesc: "VaultSphere ഫീച്ചറുകൾ പഠിക്കാൻ ട്യൂട്ടോറിയൽ വീണ്ടും കാണുക.",
  viewTutorial: "ട്യൂട്ടോറിയൽ കാണുക →",
  profile: "പ്രൊഫൈൽ",
  notifications: "അറിയിപ്പുകൾ", allCaughtUp: "എല്ലാം ശരി! അറിയിപ്പുകൾ ഇല്ല.",
  markAllRead: "എല്ലാം വായിച്ചതായി അടയാളപ്പെടുത്തുക", clearAll: "എല്ലാം മായ്ക്കുക",
  searchPlaceholder: "പ്രോജക്ടുകൾ, ടാഗുകൾ തിരയുക…",
  recentProjects: "സമീപകാല പ്രോജക്ടുകൾ", noTechStack: "ടെക് സ്റ്റാക്ക് ഇല്ല", noTags: "ടാഗുകൾ ഇല്ല",
  results: "ഫലങ്ങൾ", navigate: "നാവിഗേറ്റ് ചെയ്യുക", open: "തുറക്കുക", close: "അടയ്ക്കുക",
  searchNoResults: "ന് ഫലങ്ങൾ ഇല്ല",
  pinFolder: "📌 പിൻ ചെയ്യുക", unpinFolder: "പിൻ ഒഴിവാക്കുക", pinnedFolders: "പിൻ ചെയ്ത ഫോൾഡറുകൾ",
  noPinnedFolders: "ഇതുവരെ പിൻ ചെയ്ത ഫോൾഡറുകൾ ഇല്ല", pinHint: "വേഗത്തിലുള്ള ആക്സസിന് 3 ഫോൾഡറുകൾ വരെ പിൻ ചെയ്യുക",
  editorSaving: "സേവ് ചെയ്യുന്നു…", editorSave: "💾 സേവ്",
  loadingFile: "ഫയൽ ഉള്ളടക്കം ലോഡ് ആകുന്നു…", tabHint: "Tab = 2 സ്‌പേസ് · Ctrl+S സേവ് ചെയ്യുന്നു",
  fileAppearEmpty: "ഫയൽ ശൂന്യമായി കാണുന്നു", tryReupload: "ഫയൽ വീണ്ടും അപ്‌ലോഡ് ചെയ്യാൻ ശ്രമിക്കുക",
  analysingFile: "AI ഉപയോഗിച്ച് ഫയൽ വിശകലനം ചെയ്യുന്നു…", aiMayTake: "ഇത് കുറച്ച് സെക്കൻഡ് എടുത്തേക്കാം",
  aiSummary: "📋 സംഗ്രഹം", aiKeyPoints: "🔑 പ്രധാന വിഷയങ്ങൾ", aiComplexity: "⚡ സങ്കീർണ്ണത",
  aiSuggestions: "💡 നിർദ്ദേശങ്ങൾ", aiTags: "🏷️ നിർദ്ദേശിച്ച ടാഗുകൾ",
  logout: "ലോഗ്ഔട്ട്", logoutConfirm: "നിങ്ങൾക്ക് ശരിക്കും ലോഗ്ഔട്ട് ചെയ്യണോ?",
  deleteConfirm: "റീസൈക്കിൾ ബിന്നിലേക്ക് നീക്കണോ?", deleteFileConfirm: "ഈ ഫയൽ ഇല്ലാതാക്കണോ?",
  deleteTeamConfirm: "ടീം ഇല്ലാതാക്കണോ? ഇത് പഴയ നിലയിലാക്കാൻ കഴിയില്ല.",
  permanentDeleteConfirm: "സ്ഥിരമായി ഇല്ലാതാക്കണോ? പഴയ നിലയിലാക്കാൻ കഴിയില്ല.",
  page: "പേജ്", of: "ന്റെ", prev: "← മുമ്പത്തേത്", nextPage: "അടുത്തത് →",
  loading: "ലോഡ് ആകുന്നു…", error: "പ്രശ്‌നം", success: "വിജയം",
  overdue: "കാലഹരണം", dueToday: "ഇന്ന് കാലഹരണം!", dueIn: "ൽ കാലഹരണം",
  tut_step1_title: "നിങ്ങളുടെ ആദ്യ ഫോൾഡർ സൃഷ്ടിക്കുക",
  tut_step1_desc: "VaultSphere നിങ്ങളുടെ ജോലി ഫോൾഡറുകളിൽ ക്രമീകരിക്കുന്നു. ഓരോ ഫോൾഡറിലും ഒന്നിലധികം ഫയലുകൾ ഉണ്ടാകാം.",
  tut_step1_tip: "💡 ഡാഷ്‌ബോർഡിൽ എവിടെയും N അമർത്തുക",
  tut_step2_title: "ഫോൾഡറുകളിൽ ഫയലുകൾ അപ്‌ലോഡ് ചെയ്യുക",
  tut_step2_desc: "ഏത് ഫോൾഡറും തുറന്ന് ഫയലുകൾ ഇടുക. PDF, കോഡ് ഫയലുകൾ, ചിത്രങ്ങൾ — ഏത് ഫയൽ തരവും 25MB വരെ.",
  tut_step2_tip: "💡 ഒരേ സമയം ഒന്നിലധികം ഫയലുകൾ അപ്‌ലോഡ് ചെയ്യുക",
  tut_step3_title: "AI ഫയൽ വിശകലനം",
  tut_step3_desc: "ഏത് ഫയലിലും 🤖 AI ബട്ടൺ ക്ലിക്ക് ചെയ്യുക — സംഗ്രഹം, പ്രധാന വിഷയങ്ങൾ, സങ്കീർണ്ണത, ടാഗുകൾ.",
  tut_step3_tip: "💡 കോഡ് ഫയലുകൾ, PDF, ടെക്‌സ്‌റ്റ് ഫയലുകളിൽ പ്രവർത്തിക്കുന്നു",
  tut_step4_title: "ടീം അംഗങ്ങളുമായി സഹകരിക്കുക",
  tut_step4_desc: "സഹകരണ ടാബിലേക്ക് പോയി ടീം അംഗങ്ങളെ ക്ഷണിക്കുക. റോൾ അനുസരിച്ച് ആക്സസ് നൽകുക.",
  tut_step4_tip: "💡 സ്വീകരിച്ച ക്ഷണങ്ങൾ 'എന്നോട് പങ്കിട്ടത്' ടാബിൽ കാണിക്കും",
  tut_step5_title: "നിങ്ങളുടെ സർട്ടിഫിക്കറ്റുകൾ സൂക്ഷിക്കുക",
  tut_step5_desc: "Coursera, NPTEL അല്ലെങ്കിൽ Google ൽ നിന്ന് സർട്ടിഫിക്കറ്റ് ലഭിച്ചോ? സർട്ടിഫിക്കറ്റുകൾ ടാബിൽ സൂക്ഷിക്കുക!",
  tut_step5_tip: "💡 സർട്ടിഫിക്കറ്റുകൾ സ്വയം ടാഗ് ചെയ്യപ്പെടുന്നു",
  tut_step6_title: "നിങ്ങളുടെ അനലിറ്റിക്സ് ട്രാക്ക് ചെയ്യുക",
  tut_step6_desc: "അനലിറ്റിക്സ് ടാബ് GitHub-ശൈലിയിലുള്ള ഹീറ്റ്‌മാപ്പ്, മാസ ഫയലുകൾ, ബാഡ്ജുകൾ കാണിക്കുന്നു.",
  tut_step6_tip: "💡 VaultSphere ഉപയോഗിക്കുന്നതിലൂടെ ബാഡ്ജുകൾ നേടുക",
  tut_skip: "ഒഴിവാക്കുക →", tut_next: "അടുത്തത് →", tut_back: "← തിരികെ", tut_letsgo: "പോകാം! 🚀",
  tut_nudge_title: "ഒരു കാര്യം കൂടി!", tut_nudge_desc1: "ഒരു ദ്രുത 2 മിനിറ്റ് സർവേ പൂരിപ്പിക്കാൻ കഴിയുമോ?",
  tut_nudge_desc2: "നിങ്ങളുടെ അഭിപ്രായം ഞങ്ങളുടെ AI മോഡൽ പരിശീലിപ്പിക്കുന്നു 🤖",
  tut_fill_survey: "സർവേ പൂരിപ്പിക്കുക 🚀", tut_maybe_later: "പിന്നീട് →", tut_of: "ന്റെ",
  survey_q1: "നിങ്ങൾ ആരെന്ന് പറഞ്ഞേക്കാം?",
  survey_q1_o1: "വിദ്യാർത്ഥി", survey_q1_o2: "ഡെവലപ്പർ", survey_q1_o3: "ഡിസൈനർ",
  survey_q1_o4: "ഗവേഷകൻ", survey_q1_o5: "അദ്ധ്യാപകൻ / പ്രൊഫസർ", survey_q1_o6: "മറ്റുള്ളവർ",
  survey_q2: "നിങ്ങൾ ഏത് വർഷത്തിലാണ്?",
  survey_q2_o1: "1-ആം വർഷം", survey_q2_o2: "2-ആം വർഷം", survey_q2_o3: "3-ആം വർഷം",
  survey_q2_o4: "4-ആം വർഷം", survey_q2_o5: "ബിരുദാനന്തര", survey_q2_o6: "ജോലി ചെയ്യുന്ന പ്രൊഫഷണൽ",
  survey_q3: "VaultSphere പ്രധാനമായും എന്തിനായി ഉപയോഗിക്കും?",
  survey_q3_o1: "പ്രോജക്ട് ഫയലുകൾ സൂക്ഷിക്കാൻ", survey_q3_o2: "ടീമുമായി സഹകരിക്കാൻ",
  survey_q3_o3: "അസൈൻമെന്റുകൾ ക്രമീകരിക്കാൻ", survey_q3_o4: "സർട്ടിഫിക്കറ്റുകൾ സൂക്ഷിക്കാൻ", survey_q3_o5: "മേൽ പറഞ്ഞ എല്ലാം",
  survey_q4: "ഏത് ഫീച്ചറുകൾ ഏറ്റവും ഉപയോഗപ്രദമാണ്?",
  survey_q4_o1: "AI ഫയൽ വിശകലനം", survey_q4_o2: "ടീം സഹകരണം",
  survey_q4_o3: "അനലിറ്റിക്സ് ഡാഷ്‌ബോർഡ്", survey_q4_o4: "പതിപ്പ് ചരിത്രം",
  survey_q4_o5: "സർട്ടിഫിക്കറ്റ് സ്റ്റോറേജ്", survey_q4_o6: "പബ്ലിക് ഷെയർ ലിങ്കുകൾ",
  survey_q5: "VaultSphere മൊത്തത്തിൽ എങ്ങനെ റേറ്റ് ചെയ്യും?",
  survey_q6: "ഡിസൈൻ എങ്ങനെ ഇഷ്ടപ്പെടുന്നു?",
  survey_q6_o1: "വളരെ ഇഷ്ടമാണ്! 😍", survey_q6_o2: "നന്നായിരിക്കുന്നു 👍",
  survey_q6_o3: "മെച്ചപ്പെടുത്താം 😐", survey_q6_o4: "കൂടുതൽ ജോലി വേണം 🔧",
  survey_q7: "ഏറ്റവും കൂടുതൽ മെച്ചപ്പെടുത്തണം?",
  survey_q7_o1: "വേഗമേറിയ പ്രകടനം", survey_q7_o2: "കൂടുതൽ AI ഫീച്ചറുകൾ",
  survey_q7_o3: "മെച്ചപ്പെട്ട മൊബൈൽ അനുഭവം", survey_q7_o4: "കൂടുതൽ സ്റ്റോറേജ്",
  survey_q7_o5: "ഡാർക്ക് മോഡ്", survey_q7_o6: "ഒന്നും ഇല്ല — ഇത് മികച്ചതാണ്!",
  survey_q8: "VaultSphere ഒരു സുഹൃത്തിന് ശുപാർശ ചെയ്യുമോ?",
  survey_q8_o1: "തീർച്ചയായും ഉം! 🚀", survey_q8_o2: "ഒരുപക്ഷേ ഉം", survey_q8_o3: "ഉറപ്പില്ല", survey_q8_o4: "ഒരുപക്ഷേ ഇല്ല",
  survey_q9: "മറ്റ് അഭിപ്രായം അല്ലെങ്കിൽ നിർദ്ദേശങ്ങൾ?", survey_q9_placeholder: "നിങ്ങൾ എന്ത് ചിന്തിക്കുന്നു എന്ന് പറയൂ… (ഐച്ഛികം)",
  survey_select_all: "ബാധകമായ എല്ലാം തിരഞ്ഞെടുക്കുക",
  survey_skip: "സർവേ ഒഴിവാക്കുക →", survey_back: "← തിരികെ", survey_next: "അടുത്തത് →",
  survey_submit: "സമർപ്പിക്കുക 🚀", survey_submitting: "സമർപ്പിക്കുന്നു…",
  survey_done_title: "നന്ദി!", survey_done_desc: "നിങ്ങളുടെ അഭിപ്രായം VaultSphere മെച്ചപ്പെടുത്താൻ സഹായിക്കുന്നു.",
  survey_done_btn: "ഡാഷ്‌ബോർഡിലേക്ക് പോകുക 🚀", survey_of: "ന്റെ",
  sv_shared: "🔗 പങ്കിട്ട പ്രോജക്ട്", sv_sharedBy: "പങ്കിട്ടത്", sv_description: "വിവരണം",
  sv_techStack: "ടെക് സ്റ്റാക്ക്", sv_tags: "ടാഗുകൾ", sv_attachedFile: "അറ്റാച്ച് ചെയ്ത ഫയൽ",
  sv_viewGithub: "🐙 GitHub ൽ കാണുക", sv_downloadFile: "↓ ഫയൽ ഡൗൺലോഡ് ചെയ്യുക",
  sv_notFound: "പ്രോജക്ട് കണ്ടുപിടിക്കാൻ കഴിഞ്ഞില്ല അല്ലെങ്കിൽ പങ്കിടൽ പ്രവർത്തനരഹിതമാക്കി.",
  sv_loading: "ലോഡ് ആകുന്നു…", sv_watermark: "VaultSphere ഉപയോഗിച്ച് നിർമ്മിച്ചത്",
  sv_goToVS: "← VaultSphere ലേക്ക് പോകുക",
  welcomeToVaultSphere: "VaultSphere ലേക്ക് സ്വാഗതം!",
  onboard1Desc: "നിങ്ങളുടെ വ്യക്തിഗത പ്രോജക്ട് വോൾട്ട്. നിങ്ങളുടെ ജോലി ഒരിടത്ത് സൂക്ഷിക്കുക.",
  createFirstProject: "നിങ്ങളുടെ ആദ്യ ഫോൾഡർ സൃഷ്ടിക്കുക",
  onboard2Desc: "'+ പുതിയ ഫോൾഡർ' ബട്ടൺ അമർത്തുക.",
  collaborateWithTeammates: "ടീം അംഗങ്ങളുമായി സഹകരിക്കുക",
  onboard3Desc: "ഉപയോക്താക്കളെ തിരയാൻ സഹകരണ ടാബിലേക്ക് പോകുക.",
  findAnythingInstantly: "ഉടനടി എന്തും കണ്ടെത്തുക",
  onboard4Desc: "ഗ്ലോബൽ സെർച്ച് തുറക്കാൻ / അമർത്തുക.",
  next: "അടുത്തത് →", back: "← തിരികെ", letsGo: "പോകാം! 🚀", skipTour: "ടൂർ ഒഴിവാക്കുക",
};

const resources = {
  english: { translation: EN },
  hindi: { translation: HI },
  telugu: { translation: TE },
  tamil: { translation: TA },
  malayalam: { translation: ML },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("language") || "english",
  fallbackLng: "english",
  interpolation: { escapeValue: false }
});

export default i18n;